import React from "react"

const BenefitsImage = props => (
  <svg x="0px" y="0px" viewBox="0 0 1362.64 1054.97" {...props}>
    <style>
      {
        ".benefitsImg1{fill:#fff}.benefitsImg39{fill:#d9efff}.benefitsImg66{fill:#bde3ff}.benefitsImg117{fill:#163f59}.benefitsImg118{fill:#387bff}.benefitsImg122{fill:#ff3d0d}.benefitsImg127{fill:#e2c59c}.benefitsImg128{fill:#f99b1c}.benefitsImg129{fill:#e9d6b8}.benefitsImg130{fill:#194866}.benefitsImg131{fill:#fec00f}.benefitsImg132{fill:#d1dbea}.benefitsImg133{fill:#b6c2c9}.benefitsImg134{fill:#cdd5d7}.benefitsImg138{fill:#0063cb}.benefitsImg139{fill:#7dc2f5}.benefitsImg142{fill:#73a9ff}.benefitsImg143{fill:#acd4f8}.benefitsImg144{fill:#161711}.benefitsImg145{fill:#e5e8ec}.benefitsImg146{fill:#484f59}.benefitsImg149{opacity:.2;fill:#fff}.benefitsImg150{fill:#fdbf14}.benefitsImg151{fill:#c9300a}.benefitsImg153{fill:#b0bfde}.benefitsImg154{fill:#593446}.benefitsImg155{fill:#081832}.benefitsImg157{fill:#282723}.benefitsImg234{font-family:&apos;MyriadPro-Regular&apos;}.benefitsImg235{font-size:12px}.benefitsImg236{fill:#fa0}.benefitsImg237{fill:#de3f18}.benefitsImg243{fill:#2f3844}"
      }
    </style>
    <g id="dizajn">
      <path
        d="M307.52 1038.84c95.43.79 394.94-38.18 568.47-6.42 281.24 51.46 606.7 5.37 427.97-43.71-49.95-13.72 93.62-97.46-258.7-115.07-309.27-15.46-624.33 20.94-776.83 36.62C115.93 925.94 45.64 953.1 13 965.35c-28.69 10.77-39.07 70.72 294.52 73.49z"
        fill="#e9f6ff"
      />
      <path
        className="benefitsImg117"
        d="M924.32 214.48c-50.98-1.59-26.78-25.77-62.13-43.02-13.73-6.7-24.46 6.76-29.74 12.13l-5.38 2.22c-5.56 5.65-2.62 15.05 3.02 20.6l8.69 8.55c10.06 8.02 5.19 21.56 11.67 27.95 7.26 7.15 19 7 26.39-.23.22.24.43.49.67.72 7.35 7.24 42.16 12.29 50.37 5.71 15.66-12.55 5.37-34.35-3.56-34.63z"
      />
      <path
        className="benefitsImg127"
        d="M855.6 271.42s-.39 3.18-15.85 1.71c-15.45-1.46-37.78-7.45-37.78-7.45l35.98.06c-.01 0 13.74.67 17.65 5.68z"
      />
      <path
        className="benefitsImg127"
        d="M814.01 267.98c-7.36-.48-10.76 3.02-13.76 3.97-3 .96-6.04 2.52-6.03 2.49 1.84-3.04 4.23-2.98 5.49-3.92 1.26-.95.92-.46-1.69-.82-1.48-.21-4.28 2.26-6.25 3.59-1.72 1.16-2.75 1.19-2.75 1.19s2.08-2.54 4.65-4.52c3.1-2.39 6.87-4.33 7.76-4.61 1.61-.51 6.55-.37 10.03.32 3.92.79 7.86 2.65 2.55 2.31z"
      />
      <path
        className="benefitsImg127"
        d="M801.81 265.53s-5.74 1.07-6.78 1.75c-.72.47-3.8 3.32-3.8 3.32s2.13-.21 3.43-1.27c1.29-1.07 7.15-3.8 7.15-3.8z"
      />
      <path
        className="benefitsImg128"
        d="M849.22 264.27s14.21 1.77 12.72 10.18c-.85 4.77-4.21 6.24-8.5 5.63-7.97-1.14-16.98-2.86-16.98-2.86l-3.25-13.4 16.01.45z"
      />
      <path
        className="benefitsImg128"
        d="M849.6 270.27l6.48-46.57s.58-9.99 4.15-9.47c5.15.74 13.1 15.88 13.29 19.01.37 6.38-8.85 39.18-10.04 45.72-.81 4.5-4.8-.93-9.37-1.76-8.54-1.54-4.51-6.93-4.51-6.93z"
      />
      <path
        className="benefitsImg129"
        d="M1042.17 211.94L1056.03 187.65 1072.24 188.68 1080.27 191.05 1062.32 193.71 1050.86 216.39z"
      />
      <path
        className="benefitsImg130"
        d="M1058.16 183.8l2.1.69.98 2.73 13.1.55 10.34 2.85s-.28.79-.79 1.02c-1.95.83-10.15.61-10.15.61s1.05-2.2.17-2.75c-.89-.56-11.02-.82-13.46-.68-4.21.23-6.46 1.09-6.23.55.35-.77 3.94-5.57 3.94-5.57z"
      />
      <path
        className="benefitsImg117"
        d="M973.11 257.81l38.06 4.32 33.8-59.76 11.37 5.67-34.2 72.47s-2.61 4.54-14.13 3.55c-11.21-.97-56.58-3.65-61.6-5.52-11.9-4.47 27.9-10.22 26.7-20.73z"
      />
      <path
        className="benefitsImg129"
        d="M827.78 196.09c.95.91 2 1.78 3.12 2.59 7.57 5.42 16.48 6.34 21.39 2.58 3.1 2.8 6.36 4.83 9.34 6.35 3.39 1.74 9.1 1.4 9.1 1.4 5.31 3.77 8.43 18.93-3.69 24.89-7.27 3.58-8.55-4.97-7.67-10.9.42-2.79.66-5.9-.08-7.13-2.59-4.26-4.49-4.3-7.76-4.91-5.27-.39-8.69 3.19-8.69 3.19-.34.34-.79.5-1.24.49-.87-.45-1.7-1.04-2.44-1.78l-8.43-8.29a10.204 10.204 0 01-2.95-8.48z"
      />
      <path
        className="benefitsImg129"
        d="M1011.7 199.11L1012.17 179.71 1016.1 175.03 1026.57 168.89 1034.39 170.24 1020.71 180.59 1019.85 200.94z"
      />
      <path
        className="benefitsImg130"
        d="M1012.75 175.46l3.52-2.55 1.1.85 9.71-6.26s8.86-2.39 10.6-.38c.55.65-.87 1.74-2.83 3.22-1.57 1.17-2.52 1.64-2.52 1.64s-.41-1.51-3.93-2.07c-1.12-.18-8.05 4.48-10.43 5.69-4.28 2.18-5.96 5.2-6.18 4.92-.58-.74.96-5.06.96-5.06zM934.84 289.23l8.6-.35 69.8-4.97s6.27 1.88 10.17-8.02c5.56-14.09-2.37-84.39-2.37-84.39l-10.34.24-5.09 66.37s-49-15.66-60.11-11.79c-12.98 4.51-20.45 10.67-36.83 27.7-7.21 7.5 2.34 13.98 2.34 13.98l23.83 1.23z"
      />
      <path
        className="benefitsImg131"
        d="M856.23 217.9s11.8-14.75 21.63-5.9c9.83 8.84 44.2 36.43 54.6 39.62l2.38 38.72c-28.38 1.87-51.67-12.62-53.6-15.52-6.25-9.38-28.94-45.12-25.01-56.92z"
      />
      <path
        className="benefitsImg128"
        d="M890.41 265.64c-2.77-3.8-8.49-11.92-14.03-21.02-7-11.5-17.67-9.58-11.95 1.7 6.05 11.91 13.59 23.69 16.81 28.5 1.93 2.9 20.78 17.4 49.16 15.52l-2.77-3.93c-20.3-1.92-35.43-18.31-37.22-20.77z"
      />
      <g>
        <path
          className="benefitsImg129"
          d="M873.05 281.01s4.27 4.58-15.04 2.63c-13.71-1.4-13.4-.44-47.22-9.17l44.93.72s12.43.03 17.33 5.82z"
        />
        <path
          className="benefitsImg129"
          d="M825.85 277.29c-9.21-.68-13.43 3.24-17.17 4.27-3.74 1.03-7.54 2.75-7.51 2.72 2.28-3.43 5.27-3.32 6.84-4.37 1.56-1.05 1.14-.5-2.13-.96-1.85-.26-5.33 2.5-7.8 3.97-2.13 1.29-3.42 1.31-3.42 1.31s2.58-2.84 5.78-5.06c3.87-2.66 8.56-4.8 9.66-5.1 2.01-.56 8.18-.3 12.53.55 4.92.96 9.85 3.15 3.22 2.67z"
        />
        <path
          className="benefitsImg127"
          d="M810.58 274.26s-7.15 1.11-8.45 1.87c-.9.53-4.73 3.7-4.73 3.7s2.66-.2 4.27-1.39c1.62-1.18 8.91-4.18 8.91-4.18z"
        />
        <path
          className="benefitsImg131"
          d="M862.98 273.34l-6.39-52.63s4.11-5.19 7.74-3.38c3.86 1.93 11.59 7.25 11.59 7.25s6.47 18.28 8.22 34.31c2.9 26.58 1.49 27.17-8.22 29.48-10.15 2.42-28.54-.05-28.54-.05l-4.08-15.05 19.68.07z"
        />
      </g>
      <g>
        <path
          className="benefitsImg132"
          d="M831.46 285.97c.01-.02.02-.04.03-.07l-.03-2.03h-84.17v2.03s-.01.04 0 .07l.22.38c1.08 1.76 3.02 2.08 5.24 2.08H826c2.23 0 4.16-.32 5.25-2.08l.21-.38z"
        />
        <path
          className="benefitsImg133"
          d="M811.17 286.31s-.02.04 0 .06l.21.31c.33.46.75.79 1.23 1.04h12.8c2.14 0 4.01-.26 5.05-1.68l.2-.31c.01-.02.03-.03.04-.05l-.02-1h-19.5v1.63z"
        />
        <path
          className="benefitsImg133"
          d="M757.75 284.34H799.81V285.78H757.75z"
        />
        <path
          className="benefitsImg134"
          d="M810.7 283.8l-10.91-41.36c-.29-1.09-1.41-1.97-2.49-1.97h-59.06c-1.09 0-1.74.88-1.45 1.97l10.91 41.36h63z"
        />
        <path
          className="benefitsImg133"
          d="M777.31 262.13c.56 2.11-.71 3.82-2.81 3.82-2.11 0-4.28-1.71-4.84-3.82-.55-2.11.7-3.83 2.82-3.83 2.1 0 4.27 1.72 4.83 3.83z"
        />
      </g>
      <g>
        <path
          d="M1242.49 734.21V305.22c0-11.13-9.06-20.18-20.2-20.18H525.66c-11.12 0-20.19 9.05-20.19 20.18v428.99h737.02z"
          fill="#30363d"
        />
        <path
          className="benefitsImg145"
          d="M504.03 735.03v62.02c0 11.94 9.69 21.63 21.63 21.63h696.63c11.95 0 21.64-9.69 21.64-21.63v-62.02h-739.9zM1001.41 910.05s-5.36-2.65-11.52-4.96c-6.57-2.48-14.47-5.56-19.12-7.8-8.16-3.92-8.86-6.49-11.91-19.84-3.33-14.58-6.44-45.36-7.7-58.77H796.83c-1.27 13.41-4.38 44.19-7.71 58.77-3.05 13.35-3.74 15.91-11.9 19.84-4.6 2.2-12.38 5.25-18.92 7.71-6.25 2.37-11.36 4.18-11.36 4.18s-4.96 2.76 3.01 3.14h248.1c7.49.15 3.36-2.27 3.36-2.27z"
        />
        <path
          className="benefitsImg134"
          d="M952.78 834.88c-.69-6.38-1.25-12.11-1.64-16.2H796.81c-.38 4.09-.94 9.82-1.63 16.2h157.6z"
        />
        <path
          className="benefitsImg146"
          d="M637.85 734.21L791.23 734.21 1071.62 285.04 918.24 285.04z"
        />
        <path
          className="benefitsImg146"
          d="M835.06 734.21L891.04 734.21 1171.43 285.04 1115.43 285.04z"
        />
        <path
          fill="#f1fafc"
          d="M539.73 319.64H1208.23V696.0799999999999H539.73z"
        />
        <g opacity={0.2}>
          <path
            className="benefitsImg149"
            d="M661.66 696.09L815.03 696.09 1050.01 319.64 896.63 319.64z"
          />
          <path
            className="benefitsImg149"
            d="M914.85 696.09L1149.82 319.64 1093.83 319.64 858.85 696.09z"
          />
        </g>
        <path
          className="benefitsImg139"
          d="M567.89 366.26H853.55V371.2H567.89z"
        />
        <path
          className="benefitsImg139"
          d="M567.89 375.29H805.03V380.23H567.89z"
        />
        <path
          className="benefitsImg66"
          d="M567.89 346.49H680.52V354.52H567.89z"
        />
        <path
          className="benefitsImg66"
          d="M889.72 561.13H946.72V566.08H889.72z"
        />
        <path
          className="benefitsImg139"
          d="M889.72 570.16H911.1600000000001V575.1H889.72z"
        />
        <path
          className="benefitsImg139"
          d="M890.07 610.52H942.1500000000001V615.47H890.07z"
        />
        <path
          className="benefitsImg139"
          d="M890.07 619.56H944.0400000000001V624.4899999999999H890.07z"
        />
        <path
          className="benefitsImg139"
          d="M890.07 628.59H942.46V633.52H890.07z"
        />
        <path
          className="benefitsImg139"
          d="M890.07 637.63H927.59V642.57H890.07z"
        />
        <g>
          <path
            className="benefitsImg39"
            d="M966.47 561.13H974.75V642.56H966.47z"
          />
          <path
            className="benefitsImg39"
            d="M978.62 561.13H986.91V642.56H978.62z"
          />
          <path
            className="benefitsImg39"
            d="M990.77 561.13H999.05V642.56H990.77z"
          />
          <path
            className="benefitsImg39"
            d="M1002.92 561.13H1011.2099999999999V642.56H1002.92z"
          />
          <path
            className="benefitsImg39"
            d="M1015.07 561.13H1023.36V642.56H1015.07z"
          />
          <path
            className="benefitsImg39"
            d="M1027.23 561.13H1035.52V642.56H1027.23z"
          />
          <path
            className="benefitsImg39"
            d="M1039.38 561.13H1047.67V642.56H1039.38z"
          />
          <path
            className="benefitsImg39"
            d="M1051.52 561.13H1059.82V642.56H1051.52z"
          />
          <path
            className="benefitsImg39"
            d="M1063.68 561.13H1071.97V642.56H1063.68z"
          />
          <path
            className="benefitsImg39"
            d="M1075.84 561.13H1084.12V642.56H1075.84z"
          />
          <path
            className="benefitsImg39"
            d="M1087.98 561.13H1096.27V642.56H1087.98z"
          />
          <path
            className="benefitsImg39"
            d="M1100.13 561.13H1108.41V642.56H1100.13z"
          />
          <path
            className="benefitsImg39"
            d="M1112.29 561.13H1120.57V642.56H1112.29z"
          />
          <path
            className="benefitsImg39"
            d="M1124.44 561.13H1132.72V642.56H1124.44z"
          />
          <path
            className="benefitsImg39"
            d="M1136.59 561.13H1144.87V642.56H1136.59z"
          />
          <path
            className="benefitsImg39"
            d="M1148.74 561.13H1157.03V642.56H1148.74z"
          />
          <path
            className="benefitsImg39"
            d="M1160.89 561.13H1169.18V642.56H1160.89z"
          />
          <path
            className="benefitsImg39"
            d="M1173.04 561.13H1181.32V642.56H1173.04z"
          />
          <g>
            <path
              className="benefitsImg118"
              d="M966.47 576H974.75V642.56H966.47z"
            />
            <path
              className="benefitsImg118"
              d="M978.62 585.84H986.91V642.5600000000001H978.62z"
            />
            <path
              className="benefitsImg118"
              d="M990.77 610.73H999.05V642.5600000000001H990.77z"
            />
            <path
              className="benefitsImg118"
              d="M1002.92 597.24H1011.2099999999999V642.5600000000001H1002.92z"
            />
            <path
              className="benefitsImg118"
              d="M1015.07 629.82H1023.36V642.5600000000001H1015.07z"
            />
            <path
              className="benefitsImg118"
              d="M1027.23 610.7H1035.52V642.57H1027.23z"
            />
            <path
              className="benefitsImg118"
              d="M1039.38 599.37H1047.67V642.56H1039.38z"
            />
            <path
              className="benefitsImg118"
              d="M1051.52 609.28H1059.82V642.56H1051.52z"
            />
            <path
              className="benefitsImg118"
              d="M1063.68 576H1071.97V642.56H1063.68z"
            />
            <path
              className="benefitsImg118"
              d="M1075.84 584.49H1084.12V642.5600000000001H1075.84z"
            />
            <path
              className="benefitsImg118"
              d="M1087.98 568.2H1096.27V642.5600000000001H1087.98z"
            />
            <path
              className="benefitsImg118"
              d="M1100.13 595.12H1108.41V642.56H1100.13z"
            />
            <path
              className="benefitsImg118"
              d="M1112.29 577.42H1120.57V642.5699999999999H1112.29z"
            />
            <path
              className="benefitsImg118"
              d="M1124.44 589.46H1132.72V642.5600000000001H1124.44z"
            />
            <path
              className="benefitsImg118"
              d="M1136.59 609.99H1144.87V642.57H1136.59z"
            />
            <path
              className="benefitsImg118"
              d="M1148.74 637.6H1157.03V642.5600000000001H1148.74z"
            />
            <path
              className="benefitsImg118"
              d="M1160.89 585.91H1169.18V642.56H1160.89z"
            />
            <path
              className="benefitsImg118"
              d="M1173.04 574.59H1181.32V642.57H1173.04z"
            />
          </g>
        </g>
        <g>
          <path
            className="benefitsImg66"
            d="M889.72 404.83H946.72V409.77H889.72z"
          />
          <path
            className="benefitsImg139"
            d="M889.72 413.86H911.1600000000001V418.79H889.72z"
          />
          <path
            className="benefitsImg139"
            d="M890.07 454.22H942.1500000000001V459.16H890.07z"
          />
          <path
            className="benefitsImg139"
            d="M890.07 463.25H944.0400000000001V468.2H890.07z"
          />
          <path
            className="benefitsImg139"
            d="M890.07 472.29H942.46V477.23H890.07z"
          />
          <path
            className="benefitsImg139"
            d="M890.07 481.32H927.59V486.27H890.07z"
          />
          <g>
            <path
              className="benefitsImg39"
              d="M966.47 404.83H974.75V486.27H966.47z"
            />
            <path
              className="benefitsImg39"
              d="M978.62 404.83H986.91V486.27H978.62z"
            />
            <path
              className="benefitsImg39"
              d="M990.77 404.83H999.05V486.27H990.77z"
            />
            <path
              className="benefitsImg39"
              d="M1002.92 404.83H1011.2099999999999V486.27H1002.92z"
            />
            <path
              className="benefitsImg39"
              d="M1015.07 404.83H1023.36V486.27H1015.07z"
            />
            <path
              className="benefitsImg39"
              d="M1027.23 404.83H1035.52V486.27H1027.23z"
            />
            <path
              className="benefitsImg39"
              d="M1039.38 404.83H1047.67V486.27H1039.38z"
            />
            <path
              className="benefitsImg39"
              d="M1051.52 404.83H1059.82V486.27H1051.52z"
            />
            <path
              className="benefitsImg39"
              d="M1063.68 404.83H1071.97V486.27H1063.68z"
            />
            <path
              className="benefitsImg39"
              d="M1075.84 404.83H1084.12V486.27H1075.84z"
            />
            <path
              className="benefitsImg39"
              d="M1087.98 404.83H1096.27V486.27H1087.98z"
            />
            <path
              className="benefitsImg39"
              d="M1100.13 404.83H1108.41V486.27H1100.13z"
            />
            <path
              className="benefitsImg39"
              d="M1112.29 404.83H1120.57V486.27H1112.29z"
            />
            <path
              className="benefitsImg39"
              d="M1124.44 404.83H1132.72V486.27H1124.44z"
            />
            <path
              className="benefitsImg39"
              d="M1136.59 404.83H1144.87V486.27H1136.59z"
            />
            <path
              className="benefitsImg39"
              d="M1148.74 404.83H1157.03V486.27H1148.74z"
            />
            <path
              className="benefitsImg39"
              d="M1160.89 404.83H1169.18V486.27H1160.89z"
            />
            <path
              className="benefitsImg39"
              d="M1173.04 404.83H1181.32V486.27H1173.04z"
            />
            <g>
              <path
                className="benefitsImg150"
                d="M1173.04 465.35H1181.33V486.26000000000005H1173.04z"
              />
              <path
                className="benefitsImg150"
                d="M1160.89 446.74H1169.17V486.27H1160.89z"
              />
              <path
                className="benefitsImg150"
                d="M1148.74 454.42H1157.03V486.26H1148.74z"
              />
              <path
                className="benefitsImg150"
                d="M1136.59 440.94H1144.87V486.26H1136.59z"
              />
              <path
                className="benefitsImg150"
                d="M1124.44 473.52H1132.72V486.27H1124.44z"
              />
              <path
                className="benefitsImg150"
                d="M1112.29 454.4H1120.57V486.27H1112.29z"
              />
              <path
                className="benefitsImg150"
                d="M1100.13 443.07H1108.42V486.27H1100.13z"
              />
              <path
                className="benefitsImg150"
                d="M1087.98 468.86H1096.27V486.26H1087.98z"
              />
              <path
                className="benefitsImg150"
                d="M1075.83 477.27H1084.12V486.26H1075.83z"
              />
              <path
                className="benefitsImg150"
                d="M1063.68 457.97H1071.96V486.27000000000004H1063.68z"
              />
              <path
                className="benefitsImg150"
                d="M1051.53 448.83H1059.82V486.26H1051.53z"
              />
              <path
                className="benefitsImg150"
                d="M1039.38 438.82H1047.67V486.27H1039.38z"
              />
              <path
                className="benefitsImg150"
                d="M1027.23 445.6H1035.52V486.27000000000004H1027.23z"
              />
              <path
                className="benefitsImg150"
                d="M1015.07 433.16H1023.36V486.26000000000005H1015.07z"
              />
              <path
                className="benefitsImg150"
                d="M1002.92 453.69H1011.2099999999999V486.26H1002.92z"
              />
              <path
                className="benefitsImg150"
                d="M990.77 458.99H999.06V486.26H990.77z"
              />
              <path
                className="benefitsImg150"
                d="M978.62 429.61H986.91V486.26H978.62z"
              />
              <path
                className="benefitsImg150"
                d="M966.47 418.28H974.75V486.26H966.47z"
              />
            </g>
          </g>
        </g>
        <g>
          <path
            className="benefitsImg150"
            d="M672.96 420.01c.69 0 .44-1.09 1.42-.79 1.33.5 2.07 1.66 3.92 1.59 1.21-.94-1.7-1.77-.72-2.39.54.22.9.6 1.45.8.26-1.37-.43-1.67-.74-2.39 2.95-.17 1.98-4.18 1.44-6.36.88-.32 1.9-.51 3.2-.39-.09-1.76-1.91-1.58-2.86-2.39 1.12.18.8-1.21 2.14-.8.26-1.19-.63-1.17-.34-2.38 1.27.22.88-1.4 2.14-1.2.87-.33 3.05.78 2.84-.79.33-1.44-1.54-.4-1.78-1.21-.85-.11-.66-1.37-1.79-1.2-1.53-.23-3.21 1.46-3.92.82.23-2 3.16-1.01 3.57-2.79-.74-1.15-2.32-1.38-4.27-1.2-1.18-.45-2.59-1.05-3.23 0-.31-.58-1.16-.56-1.79-.79-1.41 1.05-4.93-.19-6.4.79-1.64.05-3.64-.3-4.32.82 0 .85.99 2.56.37 2.78-2.59-.47-4.03.26-6.43-.43-3.57.55-5.23 3.18-8.93 3.6-.34 1.44 1.63.33 1.42 1.59-1.04.96-2.96.95-3.92 1.98-.88-.51-2.02-.42-2.5 1.2 1.15-.36 1.11.62 1.78.78 0-1.05 1.79-1.05 1.79 0 .89-.23 2.42-1.77 2.52.41-1.52.17-3.68-.4-4.67.4.34 1.49 1.68 1.84 2.88 2.38 1.08.29.66-1.09 1.79-.81 1.05.8 2.16 1.56 4.27 1.21-.29 1.76.25 2.64.74 3.57-.15.92-.58 1.5-.38 2.79 1.44.76 1.66-1.83 2.5-.4.19 1.41-1.06 1.21-2.12 1.19.28 1.78 2.69 1.23 3.19 2.79-.82.68-1.79 1.15-2.51 1.98 1 .51-1.11.83-.69 1.98 2.51 1.91.55 6.47 2.46 9.16H659c1.02.04.62 1.67 1.78 1.58.36-.79.61-1.7 1.45-2-.45-2.99 1.74-3.05 1.41-5.96.93-.03.5-1.54 1.43-1.59 1.35.81 1.35-.95 2.86 0 .55-.54 1.12-1.13 1.79-1.59 1.71-.48 2.47-2.01 4.29-2.38.12-1.44 3.11-1.79 2.12-3.18-.68.91-2.19-.67-3.17-.78zm3.58-1.6c-.97-.7 0-2.63 1.04-2.38-.17.98-.94 1.32-1.04 2.38zm2.5-19.09c-.06 1.19-.82 1.5-1.45 1.99-1.09-.77-2.69-.95-4.62-.77 1.19-1.67 4.52-.96 6.07-1.22z"
          />
          <path
            className="benefitsImg150"
            d="M628.68 405.3v2.39c1.1-.27 1.31.41 2.13.41.17-1.83 2.31-3.52 3.59-2.79.56 1.68-1.88.05-1.79 1.19 1.07.6-1.25.71-1.09 1.6.95-.24 1.29.16 1.09 1.17-.84.01-1.04-.68-2.13-.38.05 1.11-1.2.78-.72 2.39 2.14-.32 3.66-.57 4.64 1.17-2.82.67-4.66-1.58-6.43-.81-.29 1.93 2.16.79 2.14 2.41 2.7-.44 6.31 1.77 7.14-1.2.91.11 1.54-.15 1.42-1.21.26-1.07-1.68.3-1.42-.77h2.5c-.02-2.12 2.18-1.83 1.78-4.38 1.84-.05 2.03-1.98 4.31-1.6.41-.95 1.15-1.6 2.49-1.59.44-.99-.8-1.92 0-2 1.48-.76 3.68.42 4.26-1.99 0-.64-1-.2-1.05-.79-5.86.9-13.8-1.16-20.02 1.58-.47 2.41 1.56 2.02 1.79 3.6-2.31.19-1.59-2.98-4.27-2.4-.11.56-.52.75-.36 1.61-.57.03-1.23-.07-1.07.79-.31 1.27.92.83 1.07 1.6zm7.49 7.15c.21.2-.23.51-.36.4-.17-.2.27-.53.36-.4zM716.48 404.5c.21-1.13 1.9-.6 1.44-2.38-3.24-.6-6.37-.73-9.28-.82-.02.71.08 1.25.35 1.61 2.26.8 4.11 2.06 7.49 1.59zM702.59 406.49c-.05.98-.66 1.24 0 1.99 1.46-.09 1.53-1.77 3.21-1.6-.1 1.77-1.78 1.77-1.79 3.58.61.53 1.19 1.06 2.51.82-.18 1.22.77 1.27 1.77 1.17.32-1.49.64-3 1.09-4.36.94 1.04 1.5 2.59 3.91 1.98.32-3.02-1.88-3.22-2.84-4.77-.1.95-.96-.45-1.45-.41-.87.07-1.44-.19-1.76-.78.84-1.07-.29-2.35-1.79-1.99-1.05.63.55 2.04-.36 2.38-.77-1.9-4.16-3.75-4.3 0 .17 1.15 1.55.95 1.8 1.99zM738.63 403.71c-.02-2.51-3.33-1.65-3.2.41 1.22 1.23 1.88-.56 3.2-.41zM758.64 406.09c2.79-.52 5.74 1.39 6.4-1.2-.84-1.53-4.1-2.19-6.03-1.18-.81.05-.16 1.67-.37 2.38zM830.75 429.95c.84-.13.66-1.39 1.77-1.19 1.88.03 1.61 2.45 3.91 1.98.49-.72-.29-2.01.4-3.17-.97-.48-2.34-2.61-3.23-.8.13-.92-.06-1.52-.36-1.98-1.93-.77-2.94-2.54-6.04-1.98-.43-.74-1.41-.87-1.8-1.6-2.32.35-2.82-1.36-5.37-.79-.47 1.15.98 2.03 0 2.39-1.02-.17-.84-1.73-1.77-2-1.05 1.23-2.96.1-5 .79-1.3-.93-1.2-3.44-3.9-2.78-.53.1-.15 1.19-.72 1.19-1.5-.72-2.95-1.51-4.3-2.38-.14.36-.28.69-.7.78.45-1.55-.86-1.17-1.79-1.19.88-.93-.41-.9-.73-1.59-1.7.69-1.59-.24-3.21-.39-.1.52-.89.33-1.43.39-.34.74 1.09 1.33 0 1.59-3.05-.53-6.93.71-9.62 0-.9-.24-1.25-1.46-2.16-1.19-1.63.43-2.74-.41-3.92-.79-.42-.16-.98.09-1.4 0-.9-.18-1.57-1.28-3.57-.8.11-1.02 1.05-1.21 1.05-2.38-.5-1.15-1.65-1.6-2.12-2.79-1.08.54-2.75.43-4.31.41-.88-.33-.74-1.81-2.13-1.58-.86.39-1.14 1.36-1.07 2.78-1.78-.65-1.17 1.4-2.52 1.18-.68-.15-.27-1.53-1.43-1.18-.91 1.07-2.19 1.78-4.25 1.58-.63.5-.95 1.34-2.14 1.2-.51.5-.18 1.94-1.09 1.98-.74.24-2.48-.64-2.14.79 0 1.47 2.09.58 1.78 2.39-1.3-.43-1.66-1.85-3.56-1.6 0 1.05.2 2.34-.73 2.38-.4-.46-.4-1.4-.36-2.38-1.39-.33-.57 1.73-2.14 1.19-.56-.7-.49-2.1-2.15-1.59-.99 1.66-2.37 2.93-3.56 4.37-2.33.2-2.13-.73-4.63-.79-.59 1.96 1.84.59 1.41 2.39-1.48-.39-3.08.2-5.36 0-1.61.73-2.48 2.25-4.29 2.78v-2.4c-.87.07-1.71.08-2.12-.38.09 2.22 0 4.22-2.13 3.97.09 1.47-1.3 1.19-2.14 1.59-.91.52.61 1.19-.38 1.6-2.08.46-2.21-2.89-2.11-3.59 1.63.02 3.48-.17 4.64.4.93-2.49-2.03-3.78-4.3-3.97-.56-.99-1.53-1.5-2.86-1.6-.5-.93-1-1.78-1.77-2.38h-3.23c-.98.74-1.87 1.62-2.83 2.38-.17-.58-.47.17-1.09 0-1.27 1.51-2.89 2.63-4.27 3.99-.41 1.81-1.13 3.27-2.14 4.36-.06-.45-.66-.33-1.05-.38v1.58c-2.27.14-2.53 2.51-3.24 4.38.7.94.82 2.52.7 4.37.38 1.07 2.26.41 2.87 1.19-.76 1.16-1.42 1.61-1.42 2.79.76-.19.66.56.69 1.2-1.25.02-2.05.62-3.19.78-.32.72-1.01 1.02-.71 2.39-2.03-.68-.8 2.29-2.49 2 .03.46-.1.69-.39.78-1.58-.19-1.88 1.08-2.87 1.61-.85.2-1.82.34-1.75 1.57.46.53 1.54.4 2.47.41-.15 1.8 1.67 1.34 1.44 3.18-.35.53-.35 1.47-1.06 1.58-1.67-.94-3.17.36-5.38 0-.36 1.31.8 4.32-.7 4.39.27 1.16 1.07 1.71.7 3.55 1.68-.38 2.19.54 3.23.81 1.35-.77 1.52-.77 2.86 0 .8-1.61 2.03-2.76 1.77-5.56 1.56-.51 1.32-3.06 3.23-3.18 1.49 1 2.13-.3 3.57-.4-1 1.56-.5 4.03 0 5.96 2.25-.21.86-2.25 1.08-4.38-.38 0-.46-.69 0-.79v.79c.73.13.69 1.07 1.07 1.6 1.73.05 2.83.81 3.2 2.38-.07.86-.91.86-1.78.79-.05 1.41 1.26 1.25 1.78 1.98-.16-1.76.99-2.09 1.79-2.77.19-.9-.67-.56-.72-1.2.67-1.23 1.22 1.34 1.81 0-.99-2.09-5.42-2.45-4.29-5.55 1.07 1.81 3.09 2.66 4.29 4.36.19.31.5 1.23.69 1.6.29.49.87.94.73 1.58v2.37c.47.56 1.54.4 2.49.42.61-1.37-.65-3.33.35-4.78h1.06c-.38 1.56-.06 1.48-.35 3.17.81-.14.51 1.16 1.09 1.61 1.27 1.02 3.68.7 4.63 0 1.07.57-.93 2.06.71 2 1.47.3.05-2.58 1.81-2v2.38c-1.08.69-.34 3.36-1.81 3.57-2.61-1.05-5.83-1.42-9.29-1.57-1.03.3-.85 1.97-1.78 2.39-1.64-1.89-4.9-1.98-6.41-3.98.27-1.38-.41-1.69-.73-2.39.84-.11.82-1.06.35-1.59-2.16-.02-3.87.44-5.34 1.19-2.91-.18-5.43.07-6.8 1.59-.31-.82-1.02-1.22-2.12-1.19-.28 1.39-1.57 1.68-2.5 2.39-.95 1.85-.61 4.31-1.41 5.94-.55 1.07-2.45 2.13-3.23 3.2-.06 2.31-.88 3.8-1.8 5.17v10.33c1.25 1.55 2.3 3.27 2.89 5.57 1.64 1.08 2.73 2.78 4.99 3.18 1.44-.4 3.14-.48 5-.4.74-.65.7-2.14 2.14-2.01.66.07.22 1.36.72 1.6 1.66-.24 2.28.63 3.56.81.62-.36.92-1.11 2.15-.81.36 3.07-.76 4.47-.73 7.17 1.02 2.03 2.77 3.57 2.15 6.34.96 1.36 1.01 3.67 1.44 5.58-.9 1.82-.67 4.79-1.44 6.75 1.54 1.61 2.66 3.68 3.23 6.36v3.58c1.57 2.06 1.55 5.95 3.21 7.96 3.44-.28 5.15-2.45 8.2-3.17.56-2.2 1.64-3.75 3.21-4.79-.18-1.52.64-1.95.36-3.58.65-.36.9-1.11 2.14-.78.03-4.6 1.51-7.59 4.29-9.15.54-3.24.54-7.91 0-11.13.75-1.54 1.37-3.23 1.76-5.17.88-.67 1.59-1.42 2.52-1.99 1.69-2.75 3.22-5.68 4.99-8.33.27-1.49.75-3.53-.35-4.39-1.55-.23-1.45 1.29-2.86 1.2h-3.21c-.18-2.72-1.97-3.66-3.21-5.17.3-2.6-2.12-2.13-1.43-5.17-.62-.89-1.72-1.27-2.14-2.39.34-1.2-.49-3.08 0-3.17.86.68 1.81 2.76 1.43 3.57 1.5 1.67 2.49 3.85 3.91 5.57.84 1.66.74 4.14 2.52 5.56 2.48-.92 4.23-2.68 7.13-3.18.5-.24.06-1.53.73-1.58 1.52-.29 2.18-1.55 3.55-2-.23-1.74 1.04-1.75 1.1-3.16-.63-1.44-2.47-1.52-2.16-3.99-1.35-.19-2.28.12-2.85.78-.31-1.5-1.62-1.89-1.44-3.97-1.16.12-1.04-1.2-1.79-1.57.54-.22.91-.58 1.45-.79 1.98 1.37 1.36 5.6 4.98 5.15.16.78 1.01.74.71 2.01 1.73.19 1.99-1.25 3.59-1.19.34.24.36.9 1.06.78 2.48-.39 3.1 1.34 4.64 1.98-.59-.14-.69.33-.72.82.38.76 1.65.54 2.17 1.18-.18 1.24.64 1.41.34 2.79 1.07 1.33 1.54 3.32 2.14 5.17.73.76 1.49 1.52 1.8 2.77v2.4c.43.54 1.53.38 2.48.39.45-2.54 1.74-4.14 1.41-7.56h1.43v-1.6c1.36.58.7-1.07 1.79-.79-.09-1.84 1.3-2.01 1.79-3.17.89-.75 1.89-1.35 3.21-1.58.82 1.08.84 3.07 2.16 3.56.14.96-.66.87-.4 1.98.43 1.3 2.85.31 3.6 1.2-.47.84.17 1.17-.34 2.39.91.41 1.57 1.14 1.77 2.38-.12.76-1 .72-.71 1.99.12 1.2 1.11 1.41.71 3.17 1.74 1.66 3.34 3.45 5.36 4.79.09-2.63-1.68-3.17-1.78-5.59-.99-.74-1.96-1.53-2.51-2.76.16-1.29-.46-3.42.69-3.58.79 1.12 1.34 2.5 2.89 2.77.26.38.38.91.34 1.59 3.47-.49 4.31-3.94 3.93-8.73-.46-.42-1.32-.41-1.78-.8.45-1.76-1.72-1.64-.71-2.78 1.03-1.11.93 1.3 2.5.79.25-1.7 2.05-1.69 3.93-1.59 1.13-1.9 2.65-3.38 3.2-5.96.59.12.62-.38 1.09-.38.57-1.62-.09-4.6 1.05-5.56-.73-.37-1.05-1.17-1.05-2.4-.63-.49-1.42-.83-1.43-1.99-.16-.94.65-.88.34-2 .75.14 1.12-.07 1.09-.8 1-.5-1.63-2.37.71-2.37.42 1.25 1.65 1.6 2.13 2.79-.32 2.09.68 2.69 1.8 3.19 2.14-1.74-.08-6.12 1.05-9.15.77-.74 1.82-1.14 2.88-1.6.84-1.86 1.55-3.82 2.84-5.17.48-3.19-.8-6.49 0-8.75-.49 2.27.83 2.54 1.07 3.99.07 2.46.18 4.83 1.81 5.56.66-.7-.31-1.02 0-2.37.96-.04.69.66 1.42 0 .06-1.27-.96-1.35-.73-2.8-1.27-.28-1.62-1.63-2.15-2.77-.12-1.44.13-3.33-1.07-3.6-.73.11-.07 1.78-1.04 1.62-.61-2.93-3.05 1.82-3.95-1.2.25-.93.89-1.37 1.41-2 .43-1.26.29-3.13 1.42-3.59.84.99.69-.58 1.79-.38 1.68.27 3.23 1.04 5.35.8-.13.69.29.74.7.78.47-.54 1.56-.39 2.51-.4.16-1.26-.63-1.41-.36-2.76.74-.13.69-1.09 1.43-1.2.73.12.71 1.08 1.41 1.2-.13-.89 1.09-2.21 1.44-1.2-1.14 2.55-2.82 4.52-3.22 7.94.24 1.06 1.02 1.52 1.43 2.38.17 1.53.43 2.99 1.43 3.57.9-.99 1.4-2.4 2.51-3.17-.34-1.97 1.14-1.67.35-3.17.11-.81.97-.79 1.08-1.59-.54-.48-1.6-.35-1.42-1.6.33-3.49 2.67-2.72 5.33-2.38.53-.61.48-1.85 1.09-2.38 2.07-.17 3.66-1.27 4.98-1.19-.03-1.74-1.79-1.49-1.79-3.21zm-119.94 4.37c.66.82 1.62 1.36 2.83 1.6v3.97c-.78-.17.18-2.35-1.41-1.59-.79 1.36-.31 4.17-1.42 5.17-1.2.12-2.06-.19-2.88 0-.98.23-1.19 1.14-2.13 1.2.11-.49-1.03-1.37-1.07-.41-.82-.11-.82-1.08 0-1.21-.8-.94-1.37-2.19-1.43-3.96 1.79.18 1.09 5.61 4.29 3.96.8-1.59 1.35-3.52 2.13-5.17-.11-.91-.43-1.64-.72-2.38.22-3.73 2.76-4.88 3.93-7.55.44-.05.65.08.72.4-.29 2.72-3.18 2.55-2.84 5.97zm3.91 2.79c0-1.21 1.25-.98 2.16-1.19.01 1.23-1.1 1.17-2.16 1.19zm2.85-15.52c-.18-.2.27-.51.35-.4.21.23-.24.51-.35.4zm6.45 57.27c-.2-.22.23-.53.33-.41.19.18-.26.52-.33.41zm.34-49.32c-.18-.18.23-.49.36-.38.18.2-.27.5-.36.38zm26.41-6.36c-.68-.15-1.52-.13-1.41-1.18-1.09-.07.34-1.66 0 0 .25.63 1.74-.1 1.41 1.18zm22.11-7.15c-.17-.19.29-.51.4-.4.19.21-.29.51-.4.4zm1.11-.4c-.2-.21.27-.5.34-.39.18.19-.23.51-.34.39zm1.05-.8c-.17-.2.27-.5.37-.4.19.2-.26.52-.37.4zm16.06 50.09c.52-.75.8-1.76 2.14-1.58.04.62-.17 1.5.37 1.58-.54 1.18-1.56-.33-2.51 0z"
          />
          <path
            className="benefitsImg150"
            d="M664.38 511.83c-.62-.74-1.04.17-1.78.4-.57-1.35-1.94-1.81-3.21-2.39h-2.51c-.64-1.16-3.02-.36-3.21-1.97-.94-.03-2.11.22-2.13-.81 1.01-1.85-1.06-6.93-4.29-5.15-1.15-.75-1.97-1.83-2.17-3.61-1.83-.57-3.17-1.75-5-2.37-.46.14-.55.69-1.05.78-.48-1.42-2.24-1.49-2.5-3.16-1.14-.36-.75 1.02-1.42 1.19-.85-.28-.97-1.32-1.8-1.59-.32.69-.65 1.37-1.79 1.18-.52 1.65-1.95 2.29-2.84 3.59.09-1.3-.41-1.92-1.43-1.99-.93.43-1.31 1.43-2.5 1.59-.86-1.94.36-3.8 0-6.37-.64-1.38-3.03-.85-4.29-1.58.37-1.73 1.4-2.7 1.07-5.16-1.73.23-1.84.23-3.55 0-.66.85-.34 2.79-1.45 3.16-4.76.29-1.78-6.82-2.84-9.94 1.27-.33 2-1.2 3.2-1.59 1.95-.19 2.43 1.29 4.29 1.18-.01-.55-.07-1.1.35-1.18 1.74.1 4.02-.5 4.29 1.18-.16 2.32.78 3.4 2.5 3.6-.45-2.04-.24-2.67 0-3.98-.42-.58-1.04-.97-1.08-1.98.6-2.64 2.19-4.21 4.65-4.78.32-1.17.32-1.22 0-2.38.84.11 1.38-.06 1.78-.42-.89-2.17 1.15-1.68.72-4.36 1.18-.53 2.32-1.11 3.55-1.6.17-1.23-1.07-.89-.7-2.37 1.31-1.21 3.28-1.65 5.01-2.4.27 1.1-.72.82-.72 1.6 1.41-.68 2.93-1.22 3.92-2.38-.88-.64-2.65-.26-2.5-2 .21-1.1 1.4-1.1 2.14-1.57.16-.98-.64-.87-.36-2.01 1.75 1.32 3.77-1.92 5-1.18-.82 2.12-2.52 3.26-3.21 5.56 1.34.29 1.54-.66 2.85-.39.05.61-.16 1.52.36 1.59.36-.99 1.36.54 2.5 0-.17-.92-.69-2.04 0-2.78-1.29-.14-1.6-1.37-2.13-2.4.12-2.47.12-2.69 0-5.17-.67-.74-.89-.05-1.77 0 .04-1.89-1.64-1.89-1.8-3.57.27-.36.39-.9.36-1.6-1.36-.85-.86-3.82-2.84-3.97-.19.58.41 2.06-.36 2.01-.74-.24-2.37.5-2.5-.42v-3.97c-1.93.96-1.57-.92-3.23-1.2-.97 1.1-.75-.47-1.79-.38-.86-.16-.76.71-1.77.38.54 3.97-.99 6.19-.38 9.15-.61.11-1.75-1.13-2.12 0 .34 1.13 1.18.26 1.41.79-1.23.86-1.26 3.08-1.79 4.79-.78-1.23-.96-3.17-1.42-4.79-.71-.79-.69.19-1.43.39-.31-1.12-.51-.42-1.43-.39-1.06-1.2-2.28-2.23-3.92-2.77.57-1.99-1.24-1.27-1.09-2.78.77.17.7-.59.73-1.19 1.18-.69 1.68-2.1 2.86-2.79.78-1.4 1.34-3.04 3.21-3.18.06-.72-.43-.84-.36-1.6 2.43-.52 3.77-.85 5.34-1.59-.06-1.53 0-2.93.38-3.97-.43-.6-1.38-.64-1.79-1.2 1.41-.12 2.64-.01 3.2.78.66-1.21 1.73.46 2.86 0-.5 2.03 1.64 1.1 1.43 2.8-.34 2.92-4.25 1.9-4.63 4.77.59.93 2.06.86 3.57.79 2.22 1.11 3.1 3.72 6.05 3.98-.78-2.07.63-2 .37-4.38-.13-1.03-1.06-1.19-1.08-2.39 1.36.08 1.74 1.25 2.88 1.59-.11-1.05-.15-1.97 1.07-1.59-.27-1.2.36-1.45.36-2.38-.99.28-.69-.82-1.1-1.2-1.23-.2-2.14-.77-3.22-1.2.09-.81.98-.75 1.08-1.58-.45-.93-1.56-1.18-1.42-2.78h-3.23c.18-1.27-.95-1.05-1.05-1.99-1.52-.23-2.36.29-3.59.4.21-2.46-2.79-1.66-3.22-.4.16-1.47-.26-2.33-1.43-2.39-1.83 1.26-3.98 5.32-1.77 7.56.52.23 1.85-.45 1.77.38-.37 1.18-1.1 1.92-1.77 2.8-.91-.98.75-.86.35-2.38-1.23-.9-2.35-1.88-2.86-3.58-1.37.19-1.14-1.37-2.83-.8.1.96-.68.87-.38 1.99 1.23.54.77 3.7 0 4.38-.52-.34-.77-1-.71-1.98-1.81-.29-1.79 1.47-3.22 1.58-1.32-.62-2.78-1.11-3.57-2.38 1.61-.3 2.14.54 3.57.38.79-.82-.15-1.13 0-2.37 1.98-.45 2.75-2.23 4.65-2.79-.66-1.23-.54-2.19-.71-3.16h-5.36c-.78 1.11-2.53 1.11-2.84 2.77-.2-.58-.54-1-.71-1.59-.96-.01-2.24.36-1.79-1.18 2.63.62 5.81-1.47 8.19-2.41-.01 1.84 3.06 1.39 3.58.41-.25-.9-.32-2.01-.7-2.79-2.11.31-3.14 1.83-5.38 2.02v-2.39c-1.94-.75-2.3 1.86-1.05 2.39-2.05.27-3.22-.45-5-.41.53 2.05-1.64 1.1-1.79 2.37.87.51 1.12-.2 1.41.41-.21.53-.75.74-1.41.79-.57-2.27-3.41-2.05-6.09-1.98-.17 1.93-1.09 3-2.14 3.97-.05 1.25.94 1.34.74 2.79 1.75.1 2.63-.76 3.9-1.2-.73 2.17 1.96.48 2.15 1.59.27 1.09-1.68-.28-1.41.8 0 2.14 3.89-.1 3.2 2.77 1.35-.86 1.77-.63 3.21 0h.38c-.13-.46 1.02-1.37 1.06-.38-.04.47-.56.42-1.06.38.09 1.01 1.51 2.26 0 2.8-.43-.08-.3-.73-.38-1.19-3.15-.31-4.76-2.36-8.55-1.98-1.09-.37-1.12-1.94-2.5-2-.17 1.13-1.11 1.4-2.15 1.58.11-.9-.07-1.51-.34-1.97-1.4.08-1.4 1.67-2.87 1.59-1.34.3-1.7-.49-2.86-.4-.39.1-.24.78-.72.78-.34-.01-.29-.48-.34-.78-.85.13-1.35.65-2.51.4-2.86-1.98-8.34-1.03-11.41-2.78-2.66 1.29-6.15 1.66-7.84 1.98-.82 1.54.63 1.58 1.05 2.79 1.35-.18 2.21.15 2.5 1.19-1.44-.56-1.29.71-1.79 1.19-.66-.33-.97-1.02-1.76-1.19-1.38 1.54-4.63.97-5.73 2.78 1.98-.07 2.66 1.27 2.85 3.19 1.87-.75 3.3.12 4.99-.41-1.74 3.5-9.17.67-8.56 6.76 1.18.95 1.47 1.08 1.07 3.19.65.06.75-.49 1.43-.42.02.65-.18 1.53.35 1.6.51-1.27.17 1.63 1.06 1.18.46-1.54 2.06-1.89 3.22-.77-1.54 1.32-2.11 3.74-3.92 4.76-1.65.57-2.2 2.33-4.31 2.38.33 1.27-.54 1.22-.69 1.99 1.65.23 2.22-.7 3.93-.4.39-1.14 1.52-1.48 2.87-1.59 1.33-2.73 3.65-4.39 5.69-6.37h.73c.37-.36.11-1.45 1.07-1.18.02-.25.03-.48.34-.4-.01.25-.03.46-.34.4.14 1.78-.98 2.09-1.45 3.18 2.95.36 3.68-1.75 6.07-2 .17-1.77-.16-2.97-.36-4.36 1.66.37 1.74-.99 3.21-.8.98.77 1.82 1.7 2.5 2.8 2.27.79 4.22 1.95 3.93 5.55 1.73-.24.06-2.2 1.44-2.37.08 3.36-.1 6.98 1.06 9.15-1.07 1.03-.38 1.47 0 2.78 0 .77-.98.5-.7 1.59-.16 4.36-.41 7.27 0 11.51.93.67 1.58 1.69 2.48 2.39 1.01 1.54.92 4.26 2.15 5.57-.42.08-.31.73-.35 1.21 1.44.58 1.82 2.44 2.5 3.97 1.07-.31 1.02.69 2.11.37.06-1.69-.7-1.32-.7-3.55-.19 0-.39-.33 0-.41v.41c.76-.22.66.56.7 1.17 1.11.91 2.07 1.97 2.88 3.19-.27 2.81.68 4.28 1.41 5.96 2.95.82 4.7 2.87 8.23 1.99.38 1.01.87 1.93 1.42 2.79 1.34-.3 1.71.48 2.85.39.35.96 1.06 1.48 1.79 1.99v1.2c2.05.24 2.46 2.27 4.29 2.76.35-.52.34-1.46 1.06-1.56.11 1.43.74 2.37 1.08 3.57 0 .79-.97.51-.72 1.59.19 2.02-1.12 2.44-1.42 3.98-.7 2.75 1.44 4.28 0 5.56.63.75 1.76.95 2.49 1.59-.3.6-1.15.56-1.8.79-.23 3.2 1.32 4.38 3.23 5.17.17.96-.64.87-.35 1.99 1.35 1.16 1.82 3.28 3.93 3.58.65 1.77 1.79 3.04 1.79 5.56-.36.53-.36 1.46-.71 1.99.48.25.65.85.71 1.59-.98 1.79.43 3.88 0 6.34-1.95 1.3-1.05 5.75-1.79 8.37.54 1.11 1.47-.68 1.79.4.32 1.94-1.21 1.83-1.79 2.77-.44 1.29 1.15.32.72 1.59-.67.97.4 1.93-.38 3.18.36 2.71 1.55 4.09.74 6.36 1.05.96.96 3.17 2.14 3.98-.04.71.41.85.35 1.58.89.21 1.49.76 2.13 1.19 1.35-.22 3.68.67 3.93-.78-.95-.25-1.68-.79-2.13-1.62.25-1.33-1.45-.48-1.09-1.97-.13-1.74 1.01-2.05 1.09-3.58.91-.06 1.38-.57 1.43-1.58.16-1.42-1.25-.98-1.08-2.39.93-1.24 2.41-5.16 0-5.56 2.39.66 2.31-1.4 2.84-2.79 1.92.13 2.57-1.11 3.96-1.59.23-1.86-.59-2.56-.73-3.96h2.88c0-.41.41-.33.7-.42.19-.97.32-2.05 1.42-1.98-.1-2.26 1.36-2.74 2.14-4v-2.76c.67-.71 1.1-1.68 1.77-2.39 1.7-.56 1.7-.56 3.22-1.19.16-2.55 1.88-4.77.73-7.55.53-.33.77-1.02.72-2.01.55.14.61-.35 1.09-.38.1-1.31 1.04-1.75 1.41-2.78.95-1.03-.06-1.92 1.07-2.39-.28-1.21.36-1.44.36-2.39.04-1.46-.34-2.49-.7-3.56zm-16.42-65.98c.19.2-.25.5-.36.38-.18-.19.28-.49.36-.38zm-27.49-31.02c1.1.39-.4 1.07-.36 1.59-1.08-.38.16-1.34.36-1.59zm-1.43 1.99c1.12-.18 1.27.72 2.5.4-.01 1.59-1.39 1.64-2.5 1.99v-2.39zm-11.04.81c-.21-.2.22-.51.35-.41.17.21-.27.51-.35.41zm-7.51 57.24c.07-.46.34-.23.34 0-.05.46-.34.21-.34 0zm.34.79c.84.13.82 1.22 1.44 1.57-.46 1.02-1.73-.4-1.44-1.57zM737.22 420.8c-.52-1.81-2.19-2.33-1.79-5.17 2.52-.24 3.45-2.24 5.35-3.18 2.25.25 3.39-.71 3.57-2.78h-1.77c-.09.31-.02.79-.38.79-2.68.34-4.66 1.44-6.77 2.39.16 2.04-1.72 1.78-1.45 3.97-.42.84-1.34 1.16-1.4 2.39 1.14.83 2.25 1.72 3.55 2.38.15-.5.46-.81 1.09-.79zM796.83 413.65c.86-.63 1.27-1.75 2.16-2.37-1.4-.2-1.66-1.85-2.89-1.61-.14.02-.34.94-.7.79h-2.16c-.47 2.9 2.59 1.92 3.59 3.19zM682.95 431.52c.05-1.01 1.34-.62 1.79-1.18.37-2.02-.81-2.27-.7-3.98-1.59.53-2.1-.24-3.59.4-.99-.23-.89-1.66-2.15-1.58.43 1.92-1.41 1.33-1.41 2.78 1 .33.91-.55 1.79-.39-.21.96-1.4.85-1.09 2.39 1.79-.55 1.4 1.36 2.5 1.57.31-.81 2.48-.41 2.86-.01z"
          />
          <path
            className="benefitsImg150"
            d="M634.03 431.52c-1.41-.41-.5-.99-1.41-1.98-1.09.29-1.04-.68-2.13-.38-.52.75-.2 2.42-1.79 1.99.06 1.38 1.17 1.58 2.49 1.57-.13-3.11 2.43 1.3 2.84-1.2zM696.88 445.85c-.49-.41-1.09-.67-1.42-1.18.41-2.36-2.39-2.73-1.09-4.77-.49-.4-1.06-.66-1.44-1.21.54-.34 1.14-.59 1.09-1.58-1.31-.14-1.98.43-2.86.77.27 2.17-.57 3.09-.35 5.17.86.59 1.32.63 1.77.82.16 1.39-1.2 2.18-1.77 1.58-.29 1.78.23 2.63.71 3.59-.63.36-1.91-.04-1.8 1.18 1.79-.28 3.6-.54 5.75-.38.26-1.71.07-2.84 1.41-3.99z"
          />
          <path
            className="benefitsImg150"
            d="M687.23 447.45c.8-.44 2.16-.26 2.85-.8-.37-1.66-.09-1.76 0-3.6h-1.79c-.04 1.79-.8.52-1.42 1.21.06 1.13-.17 2.59.36 3.19zM809.66 458.96c.69.06.28 1.31 1.1 1.19.77-.96.66-2.96 2.14-3.16-1.89-.31-3.06-1.38-5.02-1.6.27 1.88-.39 2.73-.35 4.38.98 1.07.91-1.03 2.13-.81z"
          />
          <path
            className="benefitsImg150"
            d="M801.48 471.29c-.07 1.4.84 1.71 1.43 2.37.23-1.43 1.13-2.19 2.13-2.77.47-.01.8.2 1.05.4 1.18-1.52 3.52-1.68 4.68-3.18-.09-2.84-.8-4.95-.73-7.96h-1.41c.41 1.86-.21 2.78.36 4.77-.28.11-.43.33-.36.8-1.3.61-1.95 1.07-3.23 2.38-1.25.73-3.53.3-3.55 2.39-.16 1.09 1.93-.32 1.79.79-.74.01-1.46.01-2.16.01zM714.38 468.11c.09 1.1 1.17.33 2.11 1.19.27-1.49-.54-1.75-1.76-1.59.04.32-.14.37-.35.4zM793.96 481.61c.59.57.92 1.38 1.09 2.39 1.46-.08 1.36-1.94 1.4-3.58-.87-.86-2.1.3-2.49 1.19zM628.68 480.43v1.6h1.43c-.03-1.01-.51-1.55-1.43-1.6zM632.61 482.4c.13-.9-.04-1.5-.35-1.97h-1.09c-.11 1.35.11 2.27 1.44 1.97zM632.96 482.03v1.98c.77.17.97-.26 1.45-.41-.06-1-.52-1.53-1.45-1.57zM632.26 488.39c1.27-.24 1.73.46 2.5.79.03-1.14 1.5-.71 2.49-.79-.51-2.65-2.49-2.28-4.64-2.39.28-1.09-.71-.81-.71-1.58-.79-.45-1.96-.48-2.14-1.61h-5.34c-.16.75-.76 1.01-.73 2 1.46.16 1.44-1.3 3.19-.8 1.53.31 1.69 2.13 3.23 2.39.84.25 2.58-.51 2.84.39-1.3.05-.86.58-.69 1.6z"
          />
          <path
            className="benefitsImg150"
            d="M635.81 484.01c-.08-.55-.87-.34-1.41-.41-.76 1.48 1.83 1.82 1.41.41zM795.4 488.39c.55.95 1.27 1.77 2.14 2.38.45-1.23 1.64-1.61 1.45-3.56-.98-1.47-3.62-.81-3.59 1.18zM786.83 489.58c1-.23 1-1.55 1.43-2.38-.32-.33-.8-.45-1.43-.41-.68 1.55-.46.32 0 2.79zM628.34 487.58v1.59c1.19-.43 1.23.14 2.48-.39.24-1.58-1.34-1.13-2.48-1.2zM637.96 489.18c1.28.1 2.46.09 2.14-1.59h-2.14v1.59zM675.45 489.18c0 .78-.99.52-.72 1.59h1.43c.1-.91-.09-1.5-.71-1.59zM798.24 495.54c.75.86 1.02-.2 2.16 0-.11.91-.77 1.72.33 1.99.5-1.17 1.5-1.78 3.24-1.59.32-1.83-1.15-1.64-1.79-2.38.07-1.3-.42-1.92-1.44-2-.5.53-.33 1.73-.33 2.78-1.23-.68-1.56.24-2.17 1.2zM762.9 496.72c.52 2.36-1.34 2.85 0 3.99 1.13.18.95-1.07 1.79-1.2-.3-1.27-1.03-2.03-1.79-2.79zM786.46 507.46c.37 1.6 1.91 1.85 1.8 3.98 2.32-.59 1.96 1.78 4.29 1.2-.13-.92 1.02-.45 1.06-1.2-.27-.1-.71-.01-.71-.4 1.18-.55.61-3.04 1.8-3.57-.81-1.28.29-2.64-.37-3.57.61-.36 1.23-.74 1.07-1.97-.87-.77-1.57-1.72-3.21-1.62-.32 4.14-5.09 3.35-5.73 7.15zM779.66 504.68c-.52-.92-1.65-1.57-1.39-2.76-.98.27-.74-.82-1.45-.82.07 1.76-.86-.05-1.79.38 0 4.66 5.02 3.69 4.31 9.15 1.75.23 2.25 2.85 3.91 2.01.82-1.53-.76-3.25-.7-5.17-1.07-.81-2.36-1.95-2.89-2.79zM799.69 507.88c-.08-1.78-2.25-1.22-2.86-2.4-1.84 1.64-3.1 6.06-.38 7.54-.05-1.14.12-2 .75-2.38.77.77.82 2.03 2.13 1.2-.18-1.64-1.39-2.17-1.45-3.95.49.48 1.3.48 1.81-.01zM807.53 506.27c-1.16-.8-4.01-.65-3.91 1.19 1.21.87 3.84.45 3.91-1.19zM811.46 507.88h-2.48c-.32.57-.53 1.25-1.45 1.18-1.09.3-.68-1.11-1.75-.79.08 1.02-1.42.3-1.11 1.58.06.9.9-.49 1.79 0 1.57 1.42 3.68 2.28 5 3.98v2.39c1.92-1.29 2.5.81 3.96 1.19 1.25-.07.83-1.95 2.48-1.59.84.55 1.77 3.02 3.22 1.59-.77-.35-1.11-1.18-1.09-2.39-.92-.94-2.24-1.46-2.85-2.78v-1.2c-2.76-.11-3.52-2.45-5.72-3.16zM792.55 516.99c.17-1.4-1.27-.97-1.08-2.38-2.91.09-4.99-.82-7.15-1.6-.32.73-1 1.03-.71 2.39 3.43.06 5.02 2.11 8.94 1.59zM818.96 532.51c.13-1.88-.64-2.75-.36-4.77-.7-.27-.82-1.21-1.43-1.6-.13-3.04-2.55-3.52-2.13-7.14-.68.07-.79-.46-1.41-.41-.93 1.63.37 5.75-1.1 6.77-1.4.5-.7-1.32-2.14-.8-.05-1.12-1.69-.49-1.41-1.97-.2-1.28 1.73-.17 1.41-1.6-1.25-1.53-4.89-.38-6.76-1.18-.62.24.02 1.88-.71 1.98-1.34.24-2.53.64-3.57 1.19-.46 1.2-.15 3.31-1.45 3.58-.84-.95-1.73.05-2.84 0-.7.27.07 2.21-.71 2.37-.73-.23-.72-1.19-1.43-.4-.87 1-.48 3.43-1.8 3.98-.79.56-2.36.27-2.84 1.2.35 1.75 1.26 3.96.35 5.95.69.28.95 1.06 1.08 1.98.19 1.82-.64 2.48-.37 4.37 1.05-.1 1.11.9 2.16.81 1.48-.72 2.36-2.12 4.98-1.59 1.27-1.77 3.79-2.18 6.79-1.98 1.05.83 1.69 2.1 2.14 3.57 1.39-.74.97.92 2.5 0-.01 1.04.13 2.28-.35 2.79 2.29 1.47 3.63 1.56 7.14 1.59.91-.71 1.57-1.72 2.84-2.02-.18-2.03 1.73-1.78 1.44-3.96 1.21-.09.93-1.9 2.15-1.98-.39-1.42.61-2.26.71-3.59.18-2.41-.7-4.91-1.07-7.15-.92-.53-1.51 1.18-1.81.01zM735.79 519.8c-.62 1.16-1.18 2.4-1.44 3.98-1.53.4-2.32 1.6-3.19 2.78-.29 1.37.51 1.54.36 2.77-.32.84-.55 1.77-1.09 2.4.79 1.79-.25 3.37 1.09 4.76 1.14.07 1.5-.71 2.84-.4.79-1.78.49-2.57 1.44-4.36v-2.01c.05-.43.38-.61.7-.79-.65-1.74.68-3.38.73-6.35-1.36 0 .04-2.97-1.44-2.78zM838.59 546.82c.09-1.14.05-2.17-1.05-1.97V548c-.3 1.18-1.7 1.04-1.45 2.8 2.41-.39.83 1.18.73 2.39 2.25-.12 2.34-2.71 3.2-4.38.53-.6 1.5-.72 1.8-1.61-.88-1.21-1.55-.22-3.23-.38zM834.66 551.6c-.3.84-1.07 1.18-1.07 2.39-.61-.04-1.09.08-1.42.39-.62.79-.84 1.98-1.78 2.38-1.48.62-1.93 2.38-2.52 3.97 1.16-.65 1.93-.18 3.22 0 .34-.94 1.44-1.06 1.08-2.78h1.42c.11-2.26 2.83-1.64 2.84-3.96-.11-1.34-1.04-1.73-1.77-2.39zM810.38 552.78c-.39.61 1.16 2.38 1.43 3.58 1.73-.18 2.86-1.03 2.5-3.58-1.53.31-3.3-.51-3.93 0zM648.7 565.1h1.41c.24-1.57-1.51-1.3-1.41 0z"
          />
          <g>
            <path
              className="benefitsImg118"
              d="M614.53 465.86c-2.58 0-4.7 2.11-4.7 4.7 0 2.6 3.6 7.29 4.7 7.29 1.28 0 4.7-4.7 4.7-7.29a4.7 4.7 0 00-4.7-4.7zm0 7.36c-1.58 0-2.86-1.24-2.86-2.77 0-1.54 1.28-2.77 2.86-2.77 1.59 0 2.88 1.24 2.88 2.77 0 1.54-1.29 2.77-2.88 2.77z"
            />
            <path
              className="benefitsImg143"
              d="M614.53 473.22c-1.58 0-2.86-1.24-2.86-2.77 0-1.54 1.28-2.77 2.86-2.77 1.59 0 2.88 1.24 2.88 2.77 0 1.54-1.29 2.77-2.88 2.77z"
            />
          </g>
          <g>
            <path
              className="benefitsImg118"
              d="M639.51 450.11c-2.6 0-4.7 2.11-4.7 4.69 0 2.59 3.6 7.29 4.7 7.29 1.28 0 4.69-4.7 4.69-7.29 0-2.58-2.1-4.69-4.69-4.69zm0 7.37c-1.59 0-2.88-1.24-2.88-2.77 0-1.54 1.29-2.78 2.88-2.78 1.58 0 2.87 1.24 2.87 2.78 0 1.53-1.29 2.77-2.87 2.77z"
            />
            <path
              className="benefitsImg143"
              d="M639.51 457.48c-1.59 0-2.88-1.24-2.88-2.77 0-1.54 1.29-2.78 2.88-2.78 1.58 0 2.87 1.24 2.87 2.78 0 1.53-1.29 2.77-2.87 2.77z"
            />
          </g>
          <g>
            <path
              className="benefitsImg118"
              d="M708.73 453.55a4.7 4.7 0 00-4.7 4.7c0 2.6 3.59 7.29 4.7 7.29 1.28 0 4.69-4.7 4.69-7.29s-2.1-4.7-4.69-4.7zm0 7.38c-1.59 0-2.87-1.24-2.87-2.78 0-1.54 1.28-2.78 2.87-2.78 1.58 0 2.87 1.24 2.87 2.78-.01 1.53-1.29 2.78-2.87 2.78z"
            />
            <path
              className="benefitsImg143"
              d="M708.73 460.93c-1.59 0-2.87-1.24-2.87-2.78 0-1.54 1.28-2.78 2.87-2.78 1.58 0 2.87 1.24 2.87 2.78-.01 1.53-1.29 2.78-2.87 2.78z"
            />
          </g>
          <g>
            <path
              className="benefitsImg118"
              d="M765.51 427.97a4.69 4.69 0 00-4.69 4.69c0 2.6 3.59 7.3 4.69 7.3 1.28 0 4.69-4.7 4.69-7.3 0-2.58-2.1-4.69-4.69-4.69zm0 7.36c-1.58 0-2.87-1.23-2.87-2.77 0-1.53 1.28-2.78 2.87-2.78s2.87 1.25 2.87 2.78c0 1.54-1.28 2.77-2.87 2.77z"
            />
            <path
              className="benefitsImg143"
              d="M765.51 435.33c-1.58 0-2.87-1.23-2.87-2.77 0-1.53 1.28-2.78 2.87-2.78s2.87 1.25 2.87 2.78c0 1.54-1.28 2.77-2.87 2.77z"
            />
          </g>
          <g>
            <path
              className="benefitsImg118"
              d="M782.57 467.2a4.7 4.7 0 00-4.7 4.7c0 2.59 3.59 7.28 4.7 7.28 1.28 0 4.7-4.69 4.7-7.28-.01-2.6-2.11-4.7-4.7-4.7zm0 7.37c-1.58 0-2.87-1.24-2.87-2.78 0-1.53 1.29-2.78 2.87-2.78 1.59 0 2.87 1.24 2.87 2.78 0 1.53-1.29 2.78-2.87 2.78z"
            />
            <path
              className="benefitsImg143"
              d="M782.57 474.57c-1.58 0-2.87-1.24-2.87-2.78 0-1.53 1.29-2.78 2.87-2.78 1.59 0 2.87 1.24 2.87 2.78 0 1.53-1.29 2.78-2.87 2.78z"
            />
          </g>
          <g>
            <path
              className="benefitsImg118"
              d="M739.35 465.9c-2.59 0-4.7 2.1-4.7 4.69 0 2.6 3.59 7.29 4.7 7.29 1.27 0 4.69-4.7 4.69-7.29s-2.1-4.69-4.69-4.69zm0 7.36c-1.59 0-2.88-1.23-2.88-2.77s1.29-2.78 2.88-2.78c1.58 0 2.87 1.24 2.87 2.78 0 1.53-1.29 2.77-2.87 2.77z"
            />
            <path
              className="benefitsImg143"
              d="M739.35 473.26c-1.59 0-2.88-1.23-2.88-2.77s1.29-2.78 2.88-2.78c1.58 0 2.87 1.24 2.87 2.78 0 1.53-1.29 2.77-2.87 2.77z"
            />
          </g>
          <g>
            <path
              className="benefitsImg118"
              d="M818.72 523.34c-2.59 0-4.7 2.1-4.7 4.69 0 2.6 3.6 7.3 4.7 7.3 1.29 0 4.7-4.71 4.7-7.3a4.699 4.699 0 00-4.7-4.69zm0 7.37c-1.58 0-2.86-1.24-2.86-2.78 0-1.53 1.28-2.77 2.86-2.77 1.59 0 2.88 1.24 2.88 2.77s-1.29 2.78-2.88 2.78z"
            />
            <path
              className="benefitsImg143"
              d="M818.72 530.71c-1.58 0-2.86-1.24-2.86-2.78 0-1.53 1.28-2.77 2.86-2.77 1.59 0 2.88 1.24 2.88 2.77s-1.29 2.78-2.88 2.78z"
            />
          </g>
          <g>
            <path
              className="benefitsImg118"
              d="M624.76 483.8a4.7 4.7 0 00-4.7 4.7c0 2.6 3.6 7.29 4.7 7.29 1.27 0 4.69-4.7 4.69-7.29 0-2.61-2.1-4.7-4.69-4.7zm0 7.36c-1.58 0-2.88-1.24-2.88-2.77 0-1.54 1.29-2.77 2.88-2.77 1.58 0 2.87 1.24 2.87 2.77s-1.29 2.77-2.87 2.77z"
            />
            <path
              className="benefitsImg143"
              d="M624.76 491.16c-1.58 0-2.88-1.24-2.88-2.77 0-1.54 1.29-2.77 2.88-2.77 1.58 0 2.87 1.24 2.87 2.77s-1.29 2.77-2.87 2.77z"
            />
          </g>
          <g>
            <path
              className="benefitsImg118"
              d="M692.93 431.32c-2.59 0-4.69 2.11-4.69 4.7 0 2.6 3.59 7.29 4.69 7.29 1.28 0 4.69-4.69 4.69-7.29 0-2.59-2.1-4.7-4.69-4.7zm0 7.37c-1.58 0-2.87-1.24-2.87-2.76 0-1.54 1.29-2.78 2.87-2.78 1.59 0 2.88 1.24 2.88 2.78-.01 1.52-1.29 2.76-2.88 2.76z"
            />
            <path
              className="benefitsImg143"
              d="M692.93 438.69c-1.58 0-2.87-1.24-2.87-2.76 0-1.54 1.29-2.78 2.87-2.78 1.59 0 2.88 1.24 2.88 2.78-.01 1.52-1.29 2.76-2.88 2.76z"
            />
          </g>
          <g>
            <path
              className="benefitsImg118"
              d="M729.9 430.03c-2.59 0-4.7 2.1-4.7 4.69 0 2.6 3.6 7.29 4.7 7.29 1.27 0 4.69-4.7 4.69-7.29 0-2.58-2.1-4.69-4.69-4.69zm0 7.37c-1.59 0-2.88-1.24-2.88-2.77 0-1.54 1.29-2.78 2.88-2.78 1.58 0 2.87 1.24 2.87 2.78 0 1.53-1.29 2.77-2.87 2.77z"
            />
            <path
              className="benefitsImg143"
              d="M729.9 437.4c-1.59 0-2.88-1.24-2.88-2.77 0-1.54 1.29-2.78 2.88-2.78 1.58 0 2.87 1.24 2.87 2.78 0 1.53-1.29 2.77-2.87 2.77z"
            />
          </g>
        </g>
        <g>
          <path
            className="benefitsImg66"
            d="M725.72 643.06H782.48V647.9799999999999H725.72z"
          />
          <path
            className="benefitsImg139"
            d="M725.72 652.06H747.0600000000001V656.9699999999999H725.72z"
          />
          <path
            className="benefitsImg139"
            d="M731.79 605.55a2.93 2.93 0 002.93-2.94 2.936 2.936 0 00-5.87 0c0 1.63 1.32 2.94 2.94 2.94zM737.65 607.47c-.04-.64-.53-1.11-1.13-1.2-.07-.02-.13-.04-.2-.05-3.02-.2-6.04-.2-9.06 0-.09 0-.17.03-.25.06-.58.11-1.05.57-1.08 1.19l-.56 10.19c-.03.72.51 1.34 1.23 1.37h.08c.68 0 1.27-.53 1.3-1.23l.06-1.18c.02 0 .04.01.07.01.08 0 .17 0 .25-.01-.01.08-.05.15-.05.23v10.21c0 .9.72 1.63 1.62 1.63.91 0 1.64-.72 1.64-1.63v-10.21c0-.13-.05-.22-.07-.33.19-.01.38-.01.56 0-.02.11-.07.2-.07.33v10.21c0 .9.74 1.63 1.64 1.63.89 0 1.63-.72 1.63-1.63v-10.21c0-.08-.03-.15-.05-.23.08.01.16.01.24.01.03 0 .05-.01.08-.01l.06 1.18c.04.7.62 1.23 1.31 1.23h.07c.72-.03 1.26-.65 1.23-1.37l-.55-10.19z"
          />
          <g>
            <path
              className="benefitsImg139"
              d="M746.14 601.61H858.47V607.38H746.14z"
            />
            <path
              className="benefitsImg139"
              d="M746.14 611.56H858.47V617.3299999999999H746.14z"
            />
            <path
              className="benefitsImg139"
              d="M746.14 621.51H858.47V627.27H746.14z"
            />
            <path
              className="benefitsImg150"
              d="M746.14 601.61H850.91V607.38H746.14z"
            />
            <path
              className="benefitsImg138"
              d="M746.14 611.56H785.72V617.3199999999999H746.14z"
            />
            <path
              className="benefitsImg118"
              d="M746.14 621.51H798.9V627.27H746.14z"
            />
          </g>
          <path
            className="benefitsImg66"
            d="M725.17 574.76H786.7099999999999V582.75H725.17z"
          />
          <g>
            <path
              className="benefitsImg66"
              d="M567.89 643.06H624.65V647.9799999999999H567.89z"
            />
            <path
              className="benefitsImg139"
              d="M567.89 652.06H589.23V656.9699999999999H567.89z"
            />
            <path
              className="benefitsImg139"
              d="M583.58 618.19l-3.22-10.53c-.14-.47-.53-.77-.96-.87-.01 0-.03-.03-.04-.03-2.39-.91-4.78-.91-7.18 0-.02 0-.03.03-.05.03-.44.1-.82.41-.95.87l-3.23 10.53c-.21.7.17 1.42.87 1.63.13.04.25.06.38.06.55 0 1.07-.36 1.25-.92l1.67-5.45h.16c-.4 2.05-.8 4.1-1.2 6.14-.2.95.35 1.74 1.23 1.89v5.51c0 .9.72 1.63 1.62 1.63.9 0 1.63-.72 1.63-1.63v-5.4h.44v5.4a1.63 1.63 0 003.26 0v-5.51c.87-.15 1.42-.94 1.22-1.89-.41-2.04-.8-4.1-1.2-6.14h.16l1.67 5.45c.17.55.69.92 1.24.92a1.3 1.3 0 001.23-1.69zM575.77 605.55a2.93 2.93 0 002.93-2.94c0-1.62-1.32-2.93-2.93-2.93-1.62 0-2.93 1.31-2.93 2.93a2.924 2.924 0 002.93 2.94z"
            />
            <g>
              <path
                className="benefitsImg139"
                d="M590.44 601.61H702.7700000000001V607.38H590.44z"
              />
              <path
                className="benefitsImg139"
                d="M590.44 611.56H702.7700000000001V617.3299999999999H590.44z"
              />
              <path
                className="benefitsImg139"
                d="M590.44 621.51H702.7700000000001V627.27H590.44z"
              />
              <path
                className="benefitsImg150"
                d="M590.44 601.61H633.07V607.38H590.44z"
              />
              <path
                className="benefitsImg138"
                d="M590.45 611.56H606.72V617.3199999999999H590.45z"
              />
              <path
                className="benefitsImg118"
                d="M590.44 621.51H691.9300000000001V627.27H590.44z"
              />
            </g>
            <path
              className="benefitsImg66"
              d="M567.89 574.76H629.43V582.75H567.89z"
            />
          </g>
        </g>
      </g>
      <g>
        <path
          className="benefitsImg151"
          d="M433.64 603.09L330.88 603.09 129.16 874.52 231.93 874.52z"
        />
        <path
          className="benefitsImg151"
          d="M1362.64 23.82L1360.2 230.4 1240.92 230.4 1121.67 230.4z"
        />
        <path
          className="benefitsImg122"
          d="M546.73 757.44L433.64 603.09 330.88 603.09 443.96 757.44z"
        />
        <path
          className="benefitsImg151"
          d="M546.83 759.51L751.18 474.16 648.42 474.16 444.07 759.51z"
        />
        <path
          className="benefitsImg122"
          d="M930.14 725.28L746.99 474.16 644.25 474.16 827.39 725.28z"
        />
        <path
          className="benefitsImg151"
          d="M926.92 725.28L1323.67 189.08 1220.87 189.08 824.15 725.28z"
        />
      </g>
      <g>
        <path
          className="benefitsImg129"
          d="M146.1 947.13L141.48 981.65 162.98 987.29 174.44 987.65 152.23 976.35 158.06 946.95z"
        />
        <path
          className="benefitsImg117"
          d="M135.38 777.97s43.1 81.6 43.1 87.13-19.38 86.35-19.38 86.35l-16.6 2.11s10.18-71.19 8.39-78.46c-2.36-9.58-56.87-75.71-48.56-95.95 8.31-20.22 33.05-1.18 33.05-1.18z"
        />
        <path
          className="benefitsImg144"
          d="M141.14 987.29l4.5.35 2.43-3.18 19.08 5.74 12.14.97s-.91-1.96-1.66-2.56c-2.21-1.84-11.01-5.22-11.01-5.22s.17 2.83-1.22 3.19c-1.38.35-14.56-3.35-17.69-4.6-5.37-2.12-6.61-3.83-6.94-3.53-.85.82.37 8.84.37 8.84z"
        />
        <path
          className="benefitsImg127"
          d="M253.76 833.22s.98-.91 1.72-.18c1.22 1.21 2.5 4.44 2.92 5.62.45 1.3 1.58 7.82 1.58 7.82s-1.86-1.58-2.32-4.2c-.67-3.82-3.9-9.06-3.9-9.06z"
        />
        <path
          className="benefitsImg127"
          d="M254.13 834.04c1.68 1.81 1.96 4.7 1.48 8.17-.45 3.29 1.05 4.79 1.05 4.79s.52-2.1.69-7.28c.05-1.46.02-3.05-.45-4.39-1.41-4.1-7.09-5.96-2.77-1.29z"
        />
        <path
          className="benefitsImg129"
          d="M202.32 778.24c4.07 13.25 37.96 40.95 37.96 40.95s15.43 6.71-22.43-37.7c-11.36-13.35-16.54-6.52-15.53-3.25z"
        />
        <path
          className="benefitsImg129"
          d="M254.88 836.66l.8-.94-.55-4.27s-3.97-6.65-6.35-8.6c-2.38-1.95-8.2-12.29-9.24-13.32-1.03-1.03-7.47 1.04-7.47 1.04s8.36 8.94 11.37 12.77c3.02 3.83 5.47 10.8 6.61 12.35 1.92 2.63 2.75 4.08 2.75 4.08s1.25-1.24-1.54-5.56c-.74-1.14.92-1.37.92-1.37l2.7 3.82z"
        />
        <path
          className="benefitsImg129"
          d="M253.61 831.42s2.22 3.27 2.2 5.27c-.02 1.38-1.16 7.91-1.16 7.91s-1.21-2.14-.75-4.76c.66-3.83-.29-8.42-.29-8.42z"
        />
        <path
          className="benefitsImg153"
          d="M232.07 793.97l-13.55-19.3s-15.87-49.5-21.76-52.06c-6.99-3.02-18.9-3.59-18.9-3.59l20.21 59.66 12.16 24 21.84-8.71z"
        />
        <path
          className="benefitsImg122"
          d="M126.46 806.71s18.83 3.86 23.2 0c5.74-5.07 2.41-17.14 11.52-28.61 9.12-11.47 12.79-14.46 16.61-16.86 3.83-2.4 9.1-4.34 10.87-9.88 1.79-5.51 4.93-14.46 4.23-16.25-1.12-2.88-2.23-6.13-2.04-9.5.1-1.86-64.39 81.1-64.39 81.1z"
        />
        <g>
          <path
            className="benefitsImg129"
            d="M466.64 754.53l54.96 31.99s-2.62 4.19-6.25 4.12c-9.84-.22-31.11-5.54-40.83-10.14-13.29-6.3-25.17-15.25-25.17-15.25l17.29-10.72z"
          />
          <path
            className="benefitsImg129"
            d="M510.65 790.17l6.58 4.16s3.04 2.13 7.35 3.32c4.32 1.18 7.37-1.28 9.25-5.27 1.89-3.99 1.5-6.38 1.5-6.38s-3.69-4.23-7.83-2.2c-4.12 2.05-15.08.73-15.24 2.63-.16 1.91-1.61 3.74-1.61 3.74z"
          />
          <path
            className="benefitsImg129"
            d="M533.8 784.15L541.61 787.87 548.73 791.67 547.38 792.89 541.96 790.92 532.3 792.08 532.8 789.43z"
          />
          <path
            className="benefitsImg129"
            d="M540.34 793.61L545.42 798.7 544.45 800.24 538.56 796.14 531.19 794.17 532.8 789.43z"
          />
          <path
            className="benefitsImg129"
            d="M542.09 802.28L538.3 797.96 536.17 794.75 532.21 793.35 529.73 796.67 534.07 798.03 540 802.85z"
          />
          <path
            className="benefitsImg129"
            d="M537.12 805.13L531.67 796.3 528.79 795.5 526.97 797.68 530.86 800.71 535.36 804.95z"
          />
          <path
            className="benefitsImg129"
            d="M508.95 784.37c4.09 2.1 8.5-.09 8.5-.09s11.11-5.19 13.55-4.09c2.45 1.11 7.72.57 7.72.57s2.31.87-2.16 3.02c-2.93 1.41-5.85 1.71-5.85 1.71s-5.29 5.24-7.42 5.67c-4.36.88-14.2-4.42-14.2-4.42s-.66-2.64-.14-2.37z"
          />
          <g>
            <path
              className="benefitsImg153"
              d="M447.56 737.43L484.41 764.87 477.25 781.54 449.51 775.02z"
            />
          </g>
          <path
            className="benefitsImg153"
            d="M452.34 748.02s-12.14-28.95-16.97-37.54c-3.38-6.02-14.9-19.71-14.9-19.71s-8.75 4.75-10.62 9.95c-5.39 15 2.29 32.19 2.29 32.19l37.38 42.11 8.39-8.28-5.57-18.72z"
          />
        </g>
        <g>
          <path
            className="benefitsImg129"
            d="M727.43 744.93l8.06-.11s3.84.13 8.27-1.29c4.44-1.41 5.74-5.32 5.21-9.9-.53-4.57-2.21-6.45-2.21-6.45s-5.58-1.6-8.06 2.54c-2.49 4.15-12.83 9.23-11.92 11 .93 1.77.65 4.21.65 4.21z"
          />
          <path
            className="benefitsImg129"
            d="M744.42 726.44L753.33 725.25 761.66 724.52 761.15 726.36 755.31 727.71 747.47 734.24 746.46 731.63z"
          />
          <path
            className="benefitsImg129"
            d="M755.37 730.99L762.62 732.55 762.61 734.46 755.19 734.23 747.65 736.72 746.46 731.63z"
          />
          <path
            className="benefitsImg129"
            d="M761.68 737.61L755.99 735.98 752.34 734.37 748.09 735.41 747.75 739.73 752.3 738.46 760.16 739.3z"
          />
          <path
            className="benefitsImg129"
            d="M758.89 742.94L749.24 738.3 746.27 739.25 745.87 742.19 750.95 742.63 757.24 743.8z"
          />
          <path
            className="benefitsImg129"
            d="M722.75 740.8c4.74-.48 7.39-4.92 7.39-4.92s6.89-10.88 9.64-11.31c2.77-.43 7.1-3.92 7.1-3.92s2.49-.54-.23 3.88c-1.79 2.91-4.19 4.85-4.19 4.85s-1.76 7.61-3.39 9.2c-3.34 3.27-14.88 4.22-14.88 4.22s-2.04-1.93-1.44-2z"
          />
          <path
            className="benefitsImg129"
            d="M693.29 715.51s9.71 30.79 41.13 22.08c9.34-2.59 1.24 3.08-6.97 7.95-8.21 4.85-34.43 8.14-49.2-4.82-14.77-12.97-19.28-19.16-17.15-27.01 2.13-7.87 32.19 1.8 32.19 1.8z"
          />
          <path
            className="benefitsImg154"
            d="M651.13 990.39H664.38V1010.9399999999999H651.13z"
          />
          <path
            className="benefitsImg154"
            d="M557.16 990.39H567.88V1010.9399999999999H557.16z"
          />
          <path
            className="benefitsImg155"
            d="M651.76 1016.93h9.67v-3l4.2 3h24.39s-.42-4.07-16.82-4.71c-4.22-.16-7.16-5.99-7.16-5.99s-2.1-1.93-5.25 2.56c-.82 1.17-9.67-1.07-9.67-1.07s-.83 6 .64 9.21z"
          />
          <path
            className="benefitsImg117"
            d="M663.98 763.73l1.16 111.29-23.11 12.99s-13.86-26.55-15.6-60.45c-1.74-33.88 37.55-63.83 37.55-63.83z"
          />
          <path
            className="benefitsImg130"
            d="M663.98 763.73l-50.84 122.03-9.25 13-35.07 108.19-13.25-6.12s5.02-76.89 18.12-101.08c8.93-16.46 11.71-19.64 11.71-19.64l30.62-119.77 47.96 3.39z"
          />
          <path
            className="benefitsImg117"
            d="M649.95 1004.33c-4.19-21.83-13.39-62.17-13.71-76.2-.57-25.99 3.47-44.06 3.47-44.06l25.43-9.04.1 129.31h-15.29z"
          />
          <path
            className="benefitsImg155"
            d="M569.31 1020.68h-6.55l-2.06-2.1-.89-5.15-2.08 2.13-6.83-6.97c1.18-3.32 5.94-6.96 5.94-6.96s4.7 7.96 6.09 7.73c5.36-.91 5.5 1.96 5.5 1.96s-1.96 6.21.88 9.36z"
          />
          <path
            className="benefitsImg155"
            d="M562.51 1013.14c1.26 1.43 3 2.86 5.05 2.94 16.4.65 16.82 4.71 16.82 4.71h-21.87v-7.65z"
          />
          <path
            className="benefitsImg139"
            d="M647.86 654.9s-14.26 3.7-3.73 47.31c10.54 43.62 19.78 39.51 19.78 39.51l11.12.1 22.95-24.17-10.7-11.81-2.37.71s-2.87-1.62-3.01-4.55c-.15-2.94-1.39-16.47-9.87-40.87-9.87-28.38-21.42-6.96-24.17-6.23z"
          />
          <path
            d="M671.8 708.44l7.27-3.99 3.01-1.42c.65 2.28 2.82 3.52 2.82 3.52l-5.96 1.87-6.62 3.59-7.1 7.58 6.58-11.15z"
            fill="#f4da80"
          />
          <path
            className="benefitsImg142"
            d="M665.71 765.43l-53.64 3.4-19.15-77.42s-13.87-44.06 12.71-44.63c26.57-.57 57.19-.57 57.19-.57s17.91 15.84 2.89 119.22z"
          />
          <path
            className="benefitsImg129"
            d="M618.92 591.54s27.04 25.6 23.69 34.46c-.15.39-4.4 4.55-4.88 8.76-.44 3.96 1.41 6.3 1.41 7.87 0 .52 1.36 3.92 1.51 4.92.64 4.56-1.65 8.32-3.54 7.86-2.31-.57-12.09-4.51-13.8-5.46-1.17-.66-2.27-.77-2.57-2.65-.63-4.03-2.71-10.89-4.69-12.83-5.83-5.7-22.2-11.2-17.65-27.57 1.31-4.77 18.2-16.49 20.52-15.36z"
          />
          <path
            className="benefitsImg139"
            d="M636.32 655.38L635.06 664.41 618.73 650.6 620.62 647.23z"
          />
          <path
            className="benefitsImg139"
            d="M641.12 649.54L640.64 646.5 643.64 651.72 643.78 661.3 637.33 655.57z"
          />
          <path
            className="benefitsImg127"
            d="M642.3 625.53s-1.27.3-3.73.63c-.81.12-3.18.48-4.26.97-4.76 2.19-4.33 2.47-7.46 3.21-3.57.86-11.46 1.13-11.46 1.13s3.97 1.53 5.54 2.17c2.95 1.2 5.48.78 7.49.08 8.73-2.99 8.73-2.13 9.62-2.88.06-.05.32-.73 4.26-5.31z"
          />
          <path
            className="benefitsImg129"
            d="M628.53 603.33c.42.54 6.1 3.42 7.14 3.96 1.05.54 2.42 1.17 2.53 1.61.1.43 0 2.04-.11 2.68-.1.64-.42 3.2-2.52 1.28-2.1-1.93-7.04-9.53-7.04-9.53z"
          />
          <path
            className="benefitsImg117"
            d="M596.89 606.12c1.57-8.67 12.81-16.81 25.75-16.27 0 0 1.16 1.93-.11 5.46 0 0-8.74-1.69-14.71 5.03-6.28 7.06 1.49 6.2 1.36 9.39-.11 2.68-.32 5.05-.32 5.05l2.37 4.91-1.66 1.84s-4.65-3.37-4.49-1.29c.19 2.53 3.44 5.27 3.86 5.71.42.42 1.14 1.12 1.03 1.44-.08.24 2.52 2.25 5.58 6.84-.86.78-2.96.52-5.74-1.63-6.26-4.85-14.85-15.91-12.92-26.48z"
          />
          <path
            className="benefitsImg129"
            d="M605.24 619.64a3.893 3.893 0 00-.57 5.42 3.738 3.738 0 005.32.58l-4.75-6z"
          />
          <path
            className="benefitsImg127"
            d="M633.07 613.33s2.6-3.8 3.02-4.01c.42-.22 1.36-.86 1.68-.54.32.32.56 1.66-.29 4.07-.2.59-.7-.48-4.41.48z"
          />
        </g>
        <g>
          <path
            className="benefitsImg129"
            d="M399.08 683.12L412.06 670.55 428.53 674.8 420.85 688.61 411.94 698.59z"
          />
          <path
            className="benefitsImg117"
            d="M446.16 660.09c-1.02 3.46-4.58 5.43-7.99 4.4l-23.24-7.02c-3.4-1.03-5.33-4.66-4.33-8.13 1.01-3.45 4.58-5.44 7.98-4.4l23.24 7.02c3.4 1.03 5.34 4.67 4.34 8.13z"
          />
          <path
            className="benefitsImg117"
            d="M438.72 669.65c-1.86 6.39-8.45 10.04-14.73 8.14l-12.12-3.66c-6.29-1.9-9.86-8.61-8-15 1.86-6.39 8.46-10.04 14.74-8.14l12.13 3.67c6.26 1.89 9.85 8.6 7.98 14.99z"
          />
          <path
            className="benefitsImg129"
            d="M442.45 690.94l10.54-36.18c1.68-5.77-4.59-1.39-10.26-3.1l-5.46-1.65c-5.66-1.71-11.62 1.58-13.29 7.33l-7.5 25.75 25.97 7.85z"
          />
          <path
            className="benefitsImg129"
            d="M426.15 666.79c-.73 2.53-3.34 3.98-5.83 3.23s-3.9-3.41-3.17-5.95c.74-2.53 3.35-3.97 5.84-3.22 2.49.76 3.9 3.42 3.16 5.94zM442.79 678.7c-.42 1.47.36 3.01 1.75 3.42l2.1.64c1.4.42 2.87-.43 3.3-1.91 0 0-.6-15.11-1.99-15.55 0 0-1.49.84-1.92 2.31l-3.24 11.09z"
          />
          <path
            className="benefitsImg117"
            d="M428.67 684.63c-10.25-3.1-10.38-6.62-9.61-10.37 0 0-5.41 8.34-6.27 11.29l-.96 3.29c-1.86 6.36 3.08 13.46 11 15.85l14.35 4.34 4.72-16.23 1.11-3.84-14.34-4.33z"
          />
          <path
            className="benefitsImg117"
            d="M444.98 682.24l-8.2-2.47c-3.77-1.14-7.74 1.05-8.86 4.9-.18.6-.24 1.21-.26 1.8l14.8 4.47 2.52-8.7z"
          />
          <path
            className="benefitsImg129"
            d="M432.26 686.36l-.67 2.31c-.19.65.17 1.31.8 1.5l6.64 2.01c.63.2 1.3-.17 1.48-.81l.67-2.32-8.92-2.69z"
          />
          <path
            className="benefitsImg117"
            d="M451.33 647.26l-21.03-6.35c-2.27-.68-4.65.64-5.31 2.94l-2.44 8.35 25.13 7.59 3.65-12.53z"
          />
          <path
            className="benefitsImg117"
            d="M462.54 657.43c-1.02 3.48-4.61 5.47-8.03 4.43l-14.23-4.3c-3.43-1.03-5.36-4.69-4.36-8.17 1.02-3.49 4.61-5.47 8.04-4.44l14.23 4.31c3.41 1.03 5.37 4.69 4.35 8.17z"
          />
          <path
            className="benefitsImg117"
            d="M431.55 651.64L425.88 649.92 421.44 665.16 427.12 666.87z"
          />
          <path
            className="benefitsImg117"
            d="M446.28 648.96L429.55 643.92 424.33 661.84 441.06 666.89z"
          />
          <path
            className="benefitsImg129"
            d="M428.17 663.25c1.4-4.75 6.29-7.46 10.97-6.06l4.37 1.32c4.68 1.41 6.06 6.02 4.68 10.77-1.39 4.77-6.3 7.48-10.98 6.07l-3.08-.92c-4.68-1.42-7.35-6.42-5.96-11.18z"
          />
          <path
            className="benefitsImg155"
            d="M328.75 990.21s-6.3 2.29-8.96 2.69c-2.22.33-6.16-1.12-8.11-2.01-1.78-.81-4.62-2.21-5.66-4.39-1.47-3.08-4.04-13.07-4.04-13.07l-1.8 1.26-3.16-6.85s3.65-9.32 6.52-9.76c3.84-.59 12.16 9.87 12.16 9.87l1.4 12.33 4.45 6.22s4.2.81 5.33 1.19c1.07.35 1.87 2.52 1.87 2.52zM456.39 986.07l6.84 12.07 10.43-5.17-.71-3.36 5-2.01 7.07-1.57 19.93-17.66s-.81-2.26-1.91-2.42c-3.16-.49-11.68 6.07-11.68 6.07l-16.68 3.29-18.29 10.76z"
          />
          <path
            className="benefitsImg117"
            d="M386.29 853.76L378.51 888.76 318.91 973.96 300.94 958.94 351 874.66 351.09 805.2z"
          />
          <path
            className="benefitsImg130"
            d="M377.99 769.69S421.98 879.58 435.28 905c13.29 25.42 47.27 67 47.27 67l-27.4 15.93S397.65 904 384.1 874.22c-13.55-29.77-38.98-61.02-38.98-61.02s-24.42-13.82-18.78-45.85c5.64-32.03 51.65 2.34 51.65 2.34z"
          />
          <path
            d="M423.79 708.89l-35.7 82.03-66.25-18.16s11.72-28.86 17.24-37.57c21.44-33.84 53.98-57.19 53.98-57.19s17.11-11.44 30.73 30.89z"
            fill="#bcd0e2"
          />
          <path
            className="benefitsImg153"
            d="M407.41 674.07L401.78 677.36 419.79 699.38 421.66 692.71z"
          />
        </g>
        <g>
          <path
            className="benefitsImg138"
            d="M126.06 789.75l17.83 95.78 747.74-144.16-17.82-95.78-747.75 144.16z"
          />
          <path
            className="benefitsImg118"
            d="M125.35 785.86l17.82 95.77 747.74-144.16-17.82-95.77-747.74 144.16z"
          />
          <path
            transform="rotate(-10.539 150.072 800.493)"
            className="benefitsImg146"
            d="M149.56 782.69H150.68V818.6300000000001H149.56z"
          />
          <path
            transform="rotate(-10.532 158.278 792.39)"
            className="benefitsImg146"
            d="M157.74 780.99H158.86V804H157.74z"
          />
          <path
            transform="rotate(-10.517 167.589 790.49)"
            className="benefitsImg146"
            d="M167.12 779.18H168.24V802.1999999999999H167.12z"
          />
          <path
            transform="rotate(-10.549 177 788.883)"
            className="benefitsImg146"
            d="M176.5 777.38H177.62V800.39H176.5z"
          />
          <path
            transform="rotate(-10.549 186.383 786.862)"
            className="benefitsImg146"
            d="M185.87 775.57H186.99V798.58H185.87z"
          />
          <path
            transform="rotate(-10.549 196.87 791.454)"
            className="benefitsImg146"
            d="M196.43 773.65H197.56V809.5899999999999H196.43z"
          />
          <path
            transform="rotate(-10.539 205.226 783.649)"
            className="benefitsImg146"
            d="M204.6 771.97H205.72V794.97H204.6z"
          />
          <path
            transform="rotate(-10.549 214.53 781.783)"
            className="benefitsImg146"
            d="M213.98 770.15H215.1V793.16H213.98z"
          />
          <path
            transform="rotate(-10.532 223.887 779.77)"
            className="benefitsImg146"
            d="M223.35 768.34H224.47V791.35H223.35z"
          />
          <path
            transform="rotate(-10.549 233.195 777.968)"
            className="benefitsImg146"
            d="M232.72 766.54H233.84V789.55H232.72z"
          />
          <path
            transform="rotate(-10.539 243.833 782.584)"
            className="benefitsImg146"
            d="M243.27 764.61H244.39000000000001V800.5600000000001H243.27z"
          />
          <path
            transform="rotate(-10.539 251.938 774.225)"
            className="benefitsImg146"
            d="M251.47 762.92H252.6V785.9399999999999H251.47z"
          />
          <path
            transform="rotate(-10.532 261.32 772.423)"
            className="benefitsImg146"
            d="M260.84 761.11H261.96V784.13H260.84z"
          />
          <path
            transform="rotate(-10.539 270.836 770.92)"
            className="benefitsImg146"
            d="M270.23 759.32H271.35V782.3100000000001H270.23z"
          />
          <path
            transform="rotate(-10.527 280.227 769.184)"
            className="benefitsImg146"
            d="M279.58 757.5H280.7V780.52H279.58z"
          />
          <path
            transform="rotate(-10.539 290.736 773.64)"
            className="benefitsImg146"
            d="M290.14 755.58H291.26V791.5300000000001H290.14z"
          />
          <path
            transform="rotate(-10.549 298.934 765.61)"
            className="benefitsImg146"
            d="M298.33 753.89H299.45V776.9H298.33z"
          />
          <path
            transform="rotate(-10.549 308.314 763.449)"
            className="benefitsImg146"
            d="M307.7 752.09H308.83V775.1H307.7z"
          />
          <path
            transform="rotate(-10.527 317.702 761.906)"
            className="benefitsImg146"
            d="M317.07 750.27H318.19V773.29H317.07z"
          />
          <path
            transform="rotate(-10.549 327.095 760.063)"
            className="benefitsImg146"
            d="M326.45 748.46H327.57V771.47H326.45z"
          />
          <path
            transform="rotate(-10.549 337.549 764.288)"
            className="benefitsImg146"
            d="M336.99 746.55H338.12V782.5H336.99z"
          />
          <path
            transform="rotate(-10.549 345.694 756.405)"
            className="benefitsImg146"
            d="M345.17 744.85H346.29V767.86H345.17z"
          />
          <path
            transform="rotate(-10.533 355.145 754.586)"
            className="benefitsImg146"
            d="M354.57 743.05H355.69V766.06H354.57z"
          />
          <path
            transform="rotate(-10.527 364.572 752.877)"
            className="benefitsImg146"
            d="M363.93 741.24H365.05V764.26H363.93z"
          />
          <path
            transform="rotate(-10.532 373.777 750.776)"
            className="benefitsImg146"
            d="M373.31 739.43H374.43V762.4499999999999H373.31z"
          />
          <path
            transform="rotate(-10.549 384.388 755.524)"
            className="benefitsImg146"
            d="M383.87 737.52H384.99V773.47H383.87z"
          />
          <path
            transform="rotate(-10.549 392.72 747.305)"
            className="benefitsImg146"
            d="M392.04 735.82H393.17V758.84H392.04z"
          />
          <path
            transform="rotate(-10.532 401.91 745.429)"
            className="benefitsImg146"
            d="M401.41 734.03H402.53000000000003V757.03H401.41z"
          />
          <path
            transform="rotate(-10.539 411.343 743.709)"
            className="benefitsImg146"
            d="M410.79 732.21H411.91V755.22H410.79z"
          />
          <path
            transform="rotate(-10.549 420.8 741.97)"
            className="benefitsImg146"
            d="M420.16 730.4H421.29V753.41H420.16z"
          />
          <path
            transform="rotate(-10.539 431.377 746.582)"
            className="benefitsImg146"
            d="M430.72 728.48H431.84000000000003V764.4200000000001H430.72z"
          />
          <path
            transform="rotate(-10.549 439.5 738.425)"
            className="benefitsImg146"
            d="M438.91 726.78H440.03000000000003V749.79H438.91z"
          />
          <path
            transform="rotate(-10.517 448.895 736.449)"
            className="benefitsImg146"
            d="M448.29 724.98H449.41V748H448.29z"
          />
          <path
            transform="rotate(-10.517 458.382 734.81)"
            className="benefitsImg146"
            d="M457.65 723.17H458.78V746.1899999999999H457.65z"
          />
          <path
            transform="rotate(-10.549 467.554 732.787)"
            className="benefitsImg146"
            d="M467.02 721.36H468.14V744.38H467.02z"
          />
          <path
            transform="rotate(-10.549 478.06 737.425)"
            className="benefitsImg146"
            d="M477.57 719.46H478.69V755.39H477.57z"
          />
          <path
            transform="rotate(-10.539 486.232 729.13)"
            className="benefitsImg146"
            d="M485.77 717.75H486.89V740.77H485.77z"
          />
          <path
            transform="rotate(-10.562 495.567 727.275)"
            className="benefitsImg146"
            d="M495.14 715.94H496.27V738.95H495.14z"
          />
          <path
            transform="rotate(-10.539 504.949 725.497)"
            className="benefitsImg146"
            d="M504.51 714.14H505.63V737.16H504.51z"
          />
          <path
            transform="rotate(-10.549 514.378 723.853)"
            className="benefitsImg146"
            d="M513.88 712.33H515V735.35H513.88z"
          />
          <path
            transform="rotate(-10.532 524.874 728.211)"
            className="benefitsImg146"
            d="M524.46 710.42H525.58V746.3599999999999H524.46z"
          />
          <path
            transform="rotate(-10.539 533.209 720.24)"
            className="benefitsImg146"
            d="M532.63 708.72H533.75V731.73H532.63z"
          />
          <path
            transform="rotate(-10.504 542.47 718.305)"
            className="benefitsImg146"
            d="M542.01 706.9H543.13V729.92H542.01z"
          />
          <path
            transform="rotate(-10.539 551.986 716.666)"
            className="benefitsImg146"
            d="M551.37 705.1H552.49V728.11H551.37z"
          />
          <path
            transform="rotate(-10.58 561.128 714.738)"
            className="benefitsImg146"
            d="M560.75 703.29H561.88V726.31H560.75z"
          />
          <path
            transform="rotate(-10.527 571.724 719.198)"
            className="benefitsImg146"
            d="M571.31 701.38H572.43V737.33H571.31z"
          />
          <path
            transform="rotate(-10.549 580.098 711.183)"
            className="benefitsImg146"
            d="M579.5 699.68H580.62V722.6999999999999H579.5z"
          />
          <path
            transform="rotate(-10.539 589.573 709.54)"
            className="benefitsImg146"
            d="M588.86 697.88H589.98V720.9H588.86z"
          />
          <path
            transform="rotate(-10.532 598.67 707.45)"
            className="benefitsImg146"
            d="M598.24 696.08H599.36V719.08H598.24z"
          />
          <path
            transform="rotate(-10.539 608.199 705.809)"
            className="benefitsImg146"
            d="M607.6 694.26H608.72V717.28H607.6z"
          />
          <path
            transform="rotate(-10.539 618.786 710.38)"
            className="benefitsImg146"
            d="M618.16 692.34H619.28V728.2900000000001H618.16z"
          />
          <path
            transform="rotate(-10.549 626.866 702.07)"
            className="benefitsImg146"
            d="M626.35 690.64H627.47V713.66H626.35z"
          />
          <path
            transform="rotate(-10.533 636.458 700.511)"
            className="benefitsImg146"
            d="M635.72 688.84H636.84V711.85H635.72z"
          />
          <path
            transform="rotate(-10.532 645.56 698.452)"
            className="benefitsImg146"
            d="M645.09 687.04H646.21V710.05H645.09z"
          />
          <path
            transform="rotate(-10.539 654.907 696.628)"
            className="benefitsImg146"
            d="M654.47 685.24H655.6V708.24H654.47z"
          />
          <path
            transform="rotate(-10.549 665.781 701.285)"
            className="benefitsImg146"
            d="M665.03 683.31H666.16V719.26H665.03z"
          />
          <path
            transform="rotate(-10.563 673.963 693.283)"
            className="benefitsImg146"
            d="M673.22 681.62H674.35V704.62H673.22z"
          />
          <path
            transform="rotate(-10.549 683.084 691.208)"
            className="benefitsImg146"
            d="M682.6 679.8H683.72V702.8199999999999H682.6z"
          />
          <path
            transform="rotate(-10.549 692.414 689.504)"
            className="benefitsImg146"
            d="M691.97 678H693.09V701.02H691.97z"
          />
          <path
            transform="rotate(-10.539 701.867 687.677)"
            className="benefitsImg146"
            d="M701.33 676.19H702.45V699.2H701.33z"
          />
          <path
            transform="rotate(-10.539 712.604 692.364)"
            className="benefitsImg146"
            d="M711.9 674.27H713.02V710.21H711.9z"
          />
          <path
            transform="rotate(-10.527 720.685 684.114)"
            className="benefitsImg146"
            d="M720.08 672.57H721.2V695.59H720.08z"
          />
          <path
            transform="rotate(-10.549 729.92 682.162)"
            className="benefitsImg146"
            d="M729.46 670.77H730.58V693.79H729.46z"
          />
          <path
            transform="rotate(-10.532 739.313 680.42)"
            className="benefitsImg146"
            d="M738.81 668.97H739.93V691.98H738.81z"
          />
          <path
            transform="rotate(-10.533 748.834 678.728)"
            className="benefitsImg146"
            d="M748.2 667.16H749.32V690.17H748.2z"
          />
          <path
            transform="rotate(-10.539 759.458 683.329)"
            className="benefitsImg146"
            d="M758.75 665.24H759.87V701.1800000000001H758.75z"
          />
          <path
            transform="rotate(-10.517 767.635 675.069)"
            className="benefitsImg146"
            d="M766.93 663.54H768.05V686.56H766.93z"
          />
          <path
            transform="rotate(-10.533 776.88 673.252)"
            className="benefitsImg146"
            d="M776.31 661.74H777.43V684.75H776.31z"
          />
          <path
            transform="rotate(-10.549 786.223 671.393)"
            className="benefitsImg146"
            d="M785.67 659.94H786.79V682.94H785.67z"
          />
          <path
            transform="rotate(-10.539 795.73 669.723)"
            className="benefitsImg146"
            d="M795.04 658.13H796.16V681.14H795.04z"
          />
          <path
            transform="rotate(-10.539 805.945 674.035)"
            className="benefitsImg146"
            d="M805.6 656.21H806.72V692.1600000000001H805.6z"
          />
          <path
            transform="rotate(-10.527 814.52 666.12)"
            className="benefitsImg146"
            d="M813.8 654.51H814.92V677.53H813.8z"
          />
          <path
            transform="rotate(-10.527 823.702 664.184)"
            className="benefitsImg146"
            d="M823.17 652.7H824.29V675.72H823.17z"
          />
          <path
            transform="rotate(-10.533 833.202 662.466)"
            className="benefitsImg146"
            d="M832.55 650.9H833.67V673.91H832.55z"
          />
          <path
            transform="rotate(-10.549 842.18 660.496)"
            className="benefitsImg146"
            d="M841.91 649.09H843.03V672.11H841.91z"
          />
          <path
            transform="rotate(-10.539 852.943 665.096)"
            className="benefitsImg146"
            d="M852.47 647.19H853.59V683.11H852.47z"
          />
        </g>
        <g>
          <path
            className="benefitsImg129"
            d="M412.81 750.8l32.37 55.39s-4.31 2.32-7.42.44c-8.46-5.12-24.4-20.41-30.64-29.29-8.52-12.14-14.54-25.88-14.54-25.88l20.23-.66z"
          />
          <path
            className="benefitsImg129"
            d="M435.75 800.39l1.58 6.68s.6 3.23 2.68 6.52c2.08 3.28 5.81 3.27 9.79 1.53 3.97-1.75 5.33-3.68 5.33-3.68s.4-5.08-3.75-5.99c-4.16-.89-10.61-8.05-12.02-6.79-1.39 1.27-3.61 1.73-3.61 1.73z"
          />
          <path
            className="benefitsImg129"
            d="M455.36 809.28L458.07 816.35 460.27 823.08 458.53 823.18 456.24 818.71 448.98 814.03 451.11 812.45z"
          />
          <path
            className="benefitsImg129"
            d="M453.32 819.69L453.27 826.16 451.56 826.71 450.41 820.46 446.8 814.89 451.11 812.45z"
          />
          <path
            className="benefitsImg129"
            d="M448.59 826.82L449 821.61 449.76 818.12 448.05 814.87 444.13 815.83 446.1 819.25 446.8 826.04z"
          />
          <path
            className="benefitsImg129"
            d="M443.32 826.01L445.68 816.66 444.29 814.47 441.59 814.96 442.14 819.32 442.26 824.87z"
          />
          <path
            className="benefitsImg129"
            d="M438.56 795.32c1.31 3.81 5.75 4.76 5.75 4.76s10.98 2.64 11.87 4.81c.9 2.18 4.8 4.8 4.8 4.8s.95 1.91-3.51.9c-2.92-.67-5.09-2.11-5.09-2.11s-7.11.69-8.83-.21c-3.53-1.85-6.51-11.19-6.51-11.19s1.36-2.25 1.52-1.76z"
          />
          <g>
            <path
              className="benefitsImg153"
              d="M407.29 732.07L426.09 774.43 411.8 785.35 390.82 765.78z"
            />
          </g>
          <path
            className="benefitsImg153"
            d="M406.32 743.7s3.43-31.28 3.39-41.19c-.03-6.93-3.44-24.62-3.44-24.62s-9.92-.25-14.04 3.33c-11.95 10.36-13.58 29.17-13.58 29.17l12.17 55.39 11.3-3.01 4.2-19.07z"
          />
        </g>
        <g>
          <path
            className="benefitsImg129"
            d="M562.29 738.88l22.3 63.11s-4.85 1.51-7.67-1.04c-7.65-6.92-20.97-25.76-25.61-36.08-6.35-14.12-9.83-29.38-9.83-29.38l20.81 3.39z"
          />
          <path
            className="benefitsImg129"
            d="M577.89 802.32c1.4 2.65 10.31 5.23 10.31 5.23l6.36-7.27-1.81-6.81-5.12.2-8.66 3.39c-.01.01-1.94 3.65-1.08 5.26z"
          />
          <path
            className="benefitsImg142"
            d="M596.39 689.17l-30.05 46.88-4.04.57 1.16 3.95-21.76-1.69-4.81-19.21 42.17-63.27s13.14-12.16 34.67-9.04c15.59 2.26-15.04 37.85-17.34 41.81z"
          />
          <path
            className="benefitsImg139"
            d="M543.49 726.63s13.44 6.57 20.57 9.74l-1.77.25 1.16 3.95-7.52-.65-10.54-2.53-.58-4.55h3.27l-4.59-6.21z"
          />
        </g>
        <g>
          <path
            className="benefitsImg129"
            d="M69.57 959.83L60.45 996.55 81.96 1002.22 93.4 1002.56 71.2 991.27 82.76 957.71z"
          />
          <path
            className="benefitsImg144"
            d="M60.1 1002.22l4.5.34 2.44-3.18 17.25 4.95 14.67.71s-.03-1.16-.61-1.69c-2.17-1.94-12.93-5.2-12.93-5.2s.43 3.35-.95 3.71c-1.39.36-14.66-3.71-17.78-4.94-5.37-2.14-6.61-3.84-6.93-3.53-.88.79.34 8.83.34 8.83z"
          />
          <path
            className="benefitsImg130"
            d="M91.69 779.55c-8.99 24.57 5.85 103.94 5.85 103.94s-12.06 22.39-15.33 33.82c-5.65 19.8-16.29 45.3-16.29 45.3l17.96.76s39.93-71.86 41.57-81.54c1.64-9.68 9.15-90.26-1.48-109.62-10.62-19.36-28.7-2.45-32.28 7.34z"
          />
          <path
            className="benefitsImg157"
            d="M203.29 713.54c-9.65 8.76-24.6 7.74-33.4-2.3-8.79-10.03-8.09-25.27 1.55-34.03 9.65-8.77 24.61-7.73 33.4 2.3 8.79 10.02 8.1 25.26-1.55 34.03z"
          />
          <path
            className="benefitsImg157"
            d="M179.22 735.81c-10.08 9.16-25.69 8.07-34.88-2.39-9.18-10.49-8.45-26.4 1.62-35.56 10.07-9.15 25.69-8.08 34.87 2.4 9.19 10.48 8.47 26.4-1.61 35.55zM228.73 715.87c-7.4 6.73-18.78 6.07-25.39-1.47l3.39-9.21c-6.61-7.55-5.97-19.12 1.44-25.85l5.03-4.57c7.41-6.73 18.78-6.07 25.39 1.47l3 3.42c6.61 7.54 5.96 19.12-1.44 25.85l-11.42 10.36z"
          />
          <path
            className="benefitsImg129"
            d="M243.68 692.49c-1.25 1.1-2.61 2.14-4.07 3.1-9.83 6.44-21.04 7.06-26.96 1.96-4.05 3.36-8.27 5.74-12.09 7.5-4.35 2-11.5 1.21-11.5 1.21-6.88 4.48 2.56 33.35 3.09 31.97.54-1.38 3.12-12.95 8.16-20.54 3.5-5.28 8.56-7.17 12.68-7.76 6.62-.15 10.71 4.61 10.71 4.61.4.46.95.7 1.5.71a12.8 12.8 0 003.19-2.11l11.07-10.05c3.08-2.77 4.5-6.73 4.22-10.6z"
          />
          <path
            className="benefitsImg132"
            d="M125.02 814.14s21.46-28.02 32.56-41.88c11.1-13.86 30.61-41.99 33.26-45.34 2.64-3.35 5.17-8.96 5.17-8.96s1.66-8.26-3.05-12.04c-4.71-3.77-7.36-3.92-26.7 1.38-35.31 9.67-80.56 65.89-78.3 75.1.11.45 9.96 2.3 9.96 2.3s24.45 11.02 27.1 29.44z"
          />
          <path
            className="benefitsImg153"
            d="M194.88 703.13L195.88 709.08 196.99 717.89 190.38 722.03 190.42 703.63z"
          />
          <path
            className="benefitsImg129"
            d="M197.36 826.26c4.39 10.35 10.89 12.73 14.06 16.19 3.17 3.46 7.11 6.61 7.06 6.6-4.92-.55-6.45-3.84-8.44-4.95-1.99-1.09-1.15-.95.16 2.84.74 2.17 5.6 4.37 8.54 6.22 2.54 1.59 3.29 2.97 3.29 2.97s-4.46-1.19-8.58-3.41c-4.98-2.68-9.84-6.57-10.77-7.59-1.72-1.87-4.85-8.68-6.36-13.88-1.7-5.86-2.11-12.46 1.04-4.99z"
          />
          <path
            className="benefitsImg129"
            d="M171.16 763.65s4.1-1.51 12.72 20.5c8.62 22.01 16.42 56.31 16.42 56.31l-24.13-49.07c-.01 0-8.42-19.16-5.01-27.74z"
          />
          <path
            className="benefitsImg153"
            d="M186 776.19s-8.14-20.47-18.75-15.29c-6.02 2.93-6.61 8.44-4.05 14.59 4.76 11.42 10.73 24.19 10.73 24.19l19.2.12-7.13-23.61z"
          />
          <path
            className="benefitsImg153"
            d="M183.17 764.36l4.73-47.45s-1.4-6.02-5.84-6.96c-6.41-1.36-9.74.19-11.44 3.72-3.34 6.98-2.82 3.14-6.08 30.42-2.98 24.94-4.51 35.19 6.99 37.17 10.73 1.86 11.64-16.9 11.64-16.9z"
          />
          <path
            className="benefitsImg127"
            d="M205.77 847.47s5.55 6.79 7.13 7.69c1.08.61 6.72 2.63 6.72 2.63s-1.84-2.66-4.05-3.6c-2.23-.95-9.8-6.72-9.8-6.72z"
          />
        </g>
      </g>
      <g>
        <path
          className="benefitsImg236"
          d="M421.04 361.23c-38.5-1.4-73.89 8.25-98.08 20.92-24.41 12.92-37.63 28.84-36.92 45.58.71 16.89 8.05 49.18 27.73 64.65 19.87 15.22 195.73 36.49 212.4-26.09 14.11-52.98-26.2-103.75-105.13-105.06z"
        />
        <path
          className="benefitsImg236"
          d="M380.73 475.72s1.49 33.18-40.97 57.19c0 0 17.81-48.42-5.6-68.43-14.05-12.02 46.57 11.24 46.57 11.24z"
        />
        <g>
          <path
            className="benefitsImg1"
            d="M376.2 434.11c0 4.14-3.35 7.49-7.49 7.49-4.14 0-7.49-3.35-7.49-7.49 0-4.14 3.35-7.49 7.49-7.49 4.13 0 7.49 3.35 7.49 7.49zM412.32 434.11c0 4.14-3.35 7.49-7.49 7.49-4.14 0-7.49-3.35-7.49-7.49 0-4.14 3.35-7.49 7.49-7.49 4.13 0 7.49 3.35 7.49 7.49zM448.43 434.11c0 4.14-3.35 7.49-7.49 7.49-4.14 0-7.49-3.35-7.49-7.49 0-4.14 3.35-7.49 7.49-7.49 4.14 0 7.49 3.35 7.49 7.49z"
          />
        </g>
      </g>
      <g>
        <path
          className="benefitsImg237"
          d="M434.82 346.49c0 19.04-15.44 34.48-34.48 34.48s-34.47-15.44-34.47-34.48 15.44-34.47 34.47-34.47c19.05-.01 34.48 15.43 34.48 34.47z"
        />
        <path
          className="benefitsImg1"
          d="M413.42 337.16c-3.1-3.1-8.12-3.1-11.21 0l-1.87 1.86-1.86-1.86c-3.1-3.1-8.11-3.1-11.21 0-3.09 3.09-3.09 8.11 0 11.19l1.87 1.87 11.2 11.2 11.2-11.2 1.88-1.87c3.09-3.09 3.09-8.11 0-11.19z"
        />
      </g>
      <g>
        <path
          className="benefitsImg118"
          d="M531.87 280.07c-79.49 2.68-210.22-5.18-263.31-24.16-53.61-19.42-62.07-165.22-26.27-202.47 36.27-36.82 137.97-48.08 188.56-51.3 126.05-7.99 239.14 1.6 219.4 113.59-20.5 116.23-32.35 161.43-118.38 164.34z"
        />
        <path
          className="benefitsImg118"
          d="M293.8 244.52s-2.19 44.26 54.3 76.56c0 0-23.44-64.72 7.91-91.27 18.82-15.92-62.21 14.71-62.21 14.71z"
        />
        <path
          className="benefitsImg1"
          d="M410.22 126.25l-2.55-7.65-10.39-2.96-1.56 5.46 7.51 2.14 9.7 29.08-1.69 6.06c-4.45.79-7.83 4.66-7.83 9.33 0 5.24 4.26 9.5 9.49 9.5 4.24 0 7.8-2.81 9.02-6.66h14.99c1.22 3.85 4.78 6.66 9.01 6.66 5.24 0 9.5-4.26 9.5-9.5s-4.26-9.5-9.5-9.5c-4.24 0-7.79 2.81-9.01 6.66h-14.99a9.474 9.474 0 00-5-5.73l1.13-4.05h35.33c2.62 0 4.72-1.89 4.95-4.39l6.99-24.44h-55.1zm35.7 37.64c2.11 0 3.83 1.72 3.83 3.82a3.826 3.826 0 01-7.65 0c.01-2.1 1.72-3.82 3.82-3.82zm-33.02 7.64a3.82 3.82 0 110-7.64 3.82 3.82 0 010 7.64zm39.89-22.12h-34.82l-5.47-17.47h45.28l-4.99 17.47z"
        />
        <g>
          <linearGradient
            id="SVGID_2_"
            gradientUnits="userSpaceOnUse"
            x1={556.3117}
            y1={320.1095}
            x2={556.3117}
            y2={348.4667}
          >
            <stop offset={0} stopColor="#f99b1c" />
            <stop offset={1} stopColor="#fec00f" />
          </linearGradient>
          <path
            fill="url(#SVGID_2_)"
            d="M583.93 346.98L556.31 328.05 528.69 346.98 528.69 288.49 556.31 288.49 583.93 288.49z"
          />
          <linearGradient
            id="SVGID_3_"
            gradientUnits="userSpaceOnUse"
            x1={556.3094}
            y1={220.2837}
            x2={556.3094}
            y2={280.5788}
          >
            <stop offset={0} stopColor="#f99b1c" />
            <stop offset={1} stopColor="#fec00f" />
          </linearGradient>
          <path
            d="M597.99 266.33c0 23.02-18.66 41.69-41.68 41.69-23.03 0-41.69-18.67-41.69-41.69 0-23.03 18.66-41.69 41.69-41.69 23.02 0 41.68 18.67 41.68 41.69z"
            fill="url(#SVGID_3_)"
          />
          <path
            className="benefitsImg1"
            d="M556.31 241.46L564.25 251.15 576.78 251.31 574.14 263.56 581.83 273.45 570.61 279.03 567.67 291.21 556.31 285.92 544.96 291.21 542.01 279.03 530.79 273.45 538.48 263.56 535.85 251.31 548.38 251.15z"
          />
        </g>
      </g>
      <g>
        <path
          d="M689.23 61.17c0 20.63-16.72 37.35-37.35 37.35-20.63 0-37.35-16.72-37.35-37.35s16.72-37.35 37.35-37.35c20.63 0 37.35 16.73 37.35 37.35z"
          fill="#0095ef"
        />
        <path
          className="benefitsImg1"
          d="M668.54 52.72h-13.15c.64-1.47 1.4-3.31 1.58-4.24.18-.95 0-3.22 0-3.22 0-1.71-1.38-3.09-3.09-3.09h-1.55v4.77s-5.4 6.29-5.4 8.87v15.04c0 1.71 1.39 3.09 3.09 3.09h10.8c1.7 0 3.58-1.39 4.2-3.09l5.48-15.04c.62-1.7-.26-3.09-1.96-3.09z"
        />
        <path
          className="benefitsImg1"
          d="M644.74 55.17H648.85V72.02000000000001H644.74z"
        />
        <path className="benefitsImg1" d="M632.67 52.72H640V73.95H632.67z" />
      </g>
      <path
        className="benefitsImg237"
        d="M743.48 8.62c-4.28-4.29-11.24-4.29-15.52 0l-2.59 2.58-2.59-2.58c-4.28-4.29-11.23-4.29-15.52 0-4.28 4.29-4.28 11.23 0 15.51l2.59 2.59 15.52 15.51 15.52-15.51 2.59-2.59c4.28-4.29 4.28-11.23 0-15.51z"
      />
      <g>
        <path
          d="M308.02 330.24c0 8.84-7.17 16-16.01 16-8.84 0-16-7.17-16-16 0-8.84 7.16-16.01 16-16.01s16.01 7.16 16.01 16.01z"
          fill="#f9d05e"
        />
        <path
          d="M306.69 323.83c.21 1.04.32 2.12.32 3.23 0 9.05-7.34 16.39-16.39 16.39-5.44 0-10.26-2.65-13.24-6.73 2.49 5.61 8.1 9.53 14.64 9.53 8.84 0 16.01-7.17 16.01-16-.01-2.29-.49-4.46-1.34-6.42z"
          fill="#f4c249"
        />
        <path
          className="benefitsImg243"
          d="M291.97 339.66c-2.4 0-4.78-.66-6.81-1.92l.6-.97c2.71 1.68 6.07 2.18 9.23 1.36 3.16-.82 5.86-2.88 7.41-5.67l1 .56c-1.7 3.06-4.66 5.33-8.13 6.22-1.08.28-2.19.42-3.3.42zM288.84 327.29c0 1.33-1.08 2.41-2.41 2.41s-2.41-1.08-2.41-2.41 1.08-2.41 2.41-2.41 2.41 1.08 2.41 2.41z"
        />
        <g>
          <path
            className="benefitsImg243"
            d="M301.26 329.31c-.06 0-.12-.01-.18-.03l-4.45-1.5a.58.58 0 01-.39-.54c0-.25.16-.46.4-.54l4.36-1.42a.572.572 0 11.35 1.09l-2.72.88 2.81.95a.57.57 0 01-.18 1.11z"
          />
        </g>
      </g>
    </g>
  </svg>
)

export default BenefitsImage
